// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[0].oneOf[7].use[3]!../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[4]!./variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* styles.scss */
.rootElement {
  min-height: 92vh !important;
}

.ePLeEU {
  font-size: 13px !important;
}

.overview-padding-left {
  padding-left: 10px !important;
}

.rdt_TableHeadRow {
  font-size: 15px !important;
}

#html5-qrcode-button-camera-permission {
  padding: 18px;
  background-color: #f7eeee;
  border-radius: 8px;
}

.rounded-pill {
  height: 20px !important;
  width: 20px !important;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--login-background-overlay-color);
}

.fw-datatable-row {
  font-weight: 500;
  font-size: 13px;
  color: var(--login-header-text-color);
}

.fw-bold-m {
  font-weight: bold;
}

.qc-sign-1 {
  width: 170px;
  height: 80px;
  margin-bottom: 25px;
}

.qc-sign-2 {
  width: 140px;
  height: 80px;
  margin-bottom: 25px;
}

.loginBackground {
  /* For larger mobile screens and small tablets */
  /* For larger tablets and desktops */
}
.loginBackground .innerLoginBox {
  border-radius: 10px;
  margin-top: 20vh;
}
.loginBackground .card-title,
.loginBackground label {
  color: #000;
}
.loginBackground .title {
  color: var(--login-header-text-color);
  text-align: center;
  font-size: 40px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif !important;
  z-index: 999;
}
.loginBackground .btn {
  font-weight: 600 !important;
  --bs-btn-disabled-opacity: 0.45 !important;
}
.loginBackground .btn .btn:disabled {
  opacity: 0.4 !important;
}
@media (max-width: 480px) {
  .loginBackground .card {
    height: 590px;
    width: 400px;
    padding: 16px;
    background: var(--login-card-background-color) !important;
  }
}
@media (min-width: 481px) and (max-width: 767px) {
  .loginBackground .card {
    height: 590px;
    width: 570px;
    padding: 16px;
    background: var(--login-card-background-color) !important;
  }
}
@media (min-width: 768px) and (max-width: 1200px) {
  .loginBackground .card {
    height: 590px;
    width: 570px;
    padding: 16px;
    background: var(--login-card-background-color) !important;
  }
}
@media (min-width: 1250px) {
  .loginBackground .card {
    height: 590px;
    width: 540px;
    padding: 16px;
    background: var(--login-card-background-color) !important;
  }
}
.loginBackground .deviceId {
  margin-top: 28px;
  margin-bottom: 0;
  font-weight: 600;
  font-size: 14px;
  color: #334155;
  display: flex;
  align-items: center;
  gap: 8px;
}
.loginBackground .deviceId span {
  padding: 4px 14px;
  border-radius: 12px;
  color: #fff;
  font-weight: 700;
  letter-spacing: 0.5px;
  background: linear-gradient(135deg, #273167, #273167, #273167);
  background-size: 300% 300%;
  box-shadow: 0 4px 12px rgba(39, 49, 103, 0.3960784314), 0 0 15px rgba(39, 49, 103, 0.3647058824);
  animation: deviceBadgeGlow 4s ease infinite;
}
.loginBackground .login-button {
  display: flex;
  top: 25px;
  position: relative;
}
.loginBackground .login-button button {
  border-radius: 2px !important;
  padding: 15px;
  width: 240px;
  margin: 5px;
  background-color: #0047ab;
}
.loginBackground .header {
  background-color: #131834;
  box-shadow: -1px -4px 10px 4px white;
}
.loginBackground .headerTitle {
  font-size: 30px;
  padding: 2px 18px !important;
  margin: 0px;
  font-weight: 600;
  color: #fff;
}
.loginBackground .subTitle {
  font-size: 14px;
  padding: 0px 2px !important;
  margin-bottom: 0px;
  font-weight: 600;
  color: #57ef82;
  display: block;
}
.loginBackground .headerLogo {
  width: 60px;
  border-radius: 6px;
  display: inline;
  margin-right: 14px;
}
.loginBackground .loingFont {
  font-size: 18px;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .loginBackground .headerTitle {
    font-size: 30px;
  }
  .loginBackground .subTitle {
    font-size: 12px;
  }
  .btnTable {
    margin-top: 10px !important;
    width: 100% !important;
  }
  .btnSpaceInMobile {
    padding: 6px !important;
  }
}
@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-30px);
  }
  60% {
    transform: translateY(-15px);
  }
}
.bounce {
  animation: bounce 8s infinite;
}

.supplier_app {
  font-family: sans-serif, "Helvetica Neue", "Lucida Grande", Arial;
  color: #fff !important;
}

.supplier_app1 {
  font-family: sans-serif, "Helvetica Neue", "Lucida Grande", Arial;
  color: #143ba6 !important;
}

.eyeCss {
  border: 0px;
}

.timmer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0px 13px;
  margin-bottom: 26px;
  font-size: 14px;
}

.timmer2 {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0px 13px;
  margin-bottom: 8px;
  font-size: 12px;
}
.timmer2 span {
  font-weight: bold;
}

body {
  background-color: #fff;
}

button {
  cursor: pointer !important;
}

.collapse {
  visibility: initial !important;
}

.btn {
  border: 1px solid;
  border-radius: 8px !important;
}
.btn i {
  color: var(--btn-text-color) !important;
}

.btnTable {
  background: var(--btn-table-color) !important;
  color: var(--btn-table-text-color) !important;
  border-color: var(--btn-table-border-color) !important;
  border: 1px solid;
  border-radius: 5px !important;
  font-size: 14px !important;
  padding: 8px;
  width: 90%;
}
.btnTable i {
  color: var(--btn-table-text-color) !important;
}

.btnTable:hover {
  background: var(--btn-table-hover-color) !important;
}

.btnTable:disabled {
  opacity: 0.65;
}

.btnInfo {
  background: var(--btn-table-color) !important;
  border-color: var(--btn-table-border-color) !important;
  color: var(--btn-table-text-color) !important;
  border-radius: 20px !important;
  font-size: 12px !important;
  padding: 8px;
  border: 1px solid;
  width: 200px;
}

.btnInfo:hover {
  background: var(--btn-table-hover-color) !important;
}

.btn:disabled {
  opacity: 0.4 !important;
}

.btnBack {
  background: var(--btn-table-color) !important;
  border-color: var(--btn-table-border-color) !important;
  color: var(--btn-table-text-color) !important;
  border-radius: 20px !important;
  font-size: 14px !important;
  padding: 8px;
  border: 1px solid rgba(19, 24, 52, 0.1411764706);
  width: 200px;
}

.btnBack:hover {
  background: var(--btn-table-hover-color) !important;
}

.close-btn {
  font-size: 20px;
  color: #919191;
  cursor: pointer;
}

.close-btn:hover {
  color: #000;
}

.statusColor {
  color: #007FFF !important;
}

.iconTable {
  font-size: 20px;
  padding-right: 8px;
  cursor: pointer;
}

.iconTable:hover {
  font-size: 22px;
  color: var(--header-background-color);
}

.btnCommon {
  border-radius: 20px !important;
  color: #000;
  font-size: 14px !important;
  padding: 8px;
  width: 200px;
  margin-right: 6px;
  font-weight: 600;
}

.btn-danger {
  background-color: #fd071f !important;
  border-color: #fd071f !important;
  color: #fff !important;
}

.btn-approve {
  background: linear-gradient(1deg, rgba(34, 197, 94, 0.662745098), #22c55e, rgba(34, 197, 94, 0.662745098)) !important;
  border-color: #059c3c !important;
  color: #000000 !important;
}

.btn-approve:hover {
  background: linear-gradient(359deg, #22c55e, rgba(34, 197, 94, 0.662745098), #22c55e) !important;
}

.badgeExtra {
  color: #1c1b1b !important;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.btn:focus {
  box-shadow: none !important;
}

.bg-success-wh {
  background-color: #22c55e !important;
}

.success {
  color: #22c55e !important;
}

.danger {
  color: #cf0000 !important;
}

.bg-secondary-wh {
  background-color: #bebbbb !important;
}

.bg-table-status {
  font-weight: 700;
  padding: 4px 14px;
  border-radius: 50px;
  width: 100%;
  text-align: center;
  letter-spacing: 0.5px;
}

.bg-table-documentNumber-status {
  color: #fff;
  background-color: #273167;
}

.bg-table-success-status {
  color: #008000;
  background-color: rgba(34, 139, 34, 0.231372549);
}

.bg-table-danger-status {
  color: #f30e2d;
  background-color: rgba(243, 14, 45, 0.231372549);
}

.bg-table-dark-danger-status {
  color: #ffffff;
  background-color: #f30e2d;
}

.bg-table-warning-status {
  color: #F17C1A;
  background-color: rgba(241, 123, 26, 0.2588235294);
}

.bg-table-info-status {
  color: rgba(85, 85, 85, 0.6980392157);
  background-color: rgba(85, 85, 85, 0.137254902);
}

.bg-table-progress-status {
  color: #FF8C00;
  background-color: rgba(255, 191, 0, 0.2666666667);
}

.bg-table-new-status {
  color: #002387;
  background-color: rgba(0, 36, 135, 0.231372549);
}

.bg-table-first-status {
  color: #577766;
  background-color: rgba(133, 176, 154, 0.2588235294);
}

.bg-table-second-status {
  color: #3f7d99;
  background-color: rgba(137, 207, 240, 0.2745098039);
}

.bg-table-text-status {
  color: #323232;
  background-color: rgba(99, 201, 127, 0.3411764706);
}

.bg-card-active-status {
  color: #36da36;
}

.bg-card-inactive-status {
  color: #f30e2d;
}

.bg-table-headerTag-status {
  color: #3b2a6b;
  background-color: #d7ddff;
}

.bg-table-headerTag-dev-status {
  color: #3b2a6b;
  background-color: #FFEF00;
}

.bg-table-documentNumber-status {
  color: #fff;
  background-color: #273167;
}

.bg-status {
  font-weight: 700;
  padding: 4px 16px;
  border-radius: 50px;
  width: 100%;
  text-align: center;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.bg-success-workflow {
  color: #000000;
  background-color: rgba(41, 201, 41, 0.7882352941);
}

.bg-danger-workflow {
  color: #000000;
  background-color: rgba(243, 14, 45, 0.8745098039);
}

.bg-warning-workflow {
  color: #F17C1A;
  background-color: rgba(241, 123, 26, 0.7647058824);
}

.bg-info-workflow {
  color: rgba(85, 85, 85, 0.6980392157);
  background-color: rgba(85, 85, 85, 0.7254901961);
}

.bg-pending-workflow {
  color: #FF8C00;
  background-color: rgba(255, 191, 0, 0.768627451);
}

.bg-complete-workflow {
  color: #fff;
  background-color: #138808;
}

.bg-submit-workflow {
  color: #007BA7;
  background-color: #B9D9EB;
}

.bg-new-workflow {
  color: #fff;
  background-color: #0000FF;
}

.headerStatusDetailedPage {
  position: relative;
  font-size: 16px;
  padding: 5px 17px;
  margin-left: 16px;
  top: -4px;
}

.headerStatusTag {
  position: relative;
  font-size: 14px;
  padding: 4px 16px;
  margin-left: 16px;
  letter-spacing: 1px;
  border-radius: 6px;
}

.workflow-remark {
  border: 1px solid #afa8a8;
  padding: 10px;
  border-radius: 5px;
  border-style: dashed;
  font-size: 12px;
  font-weight: 600;
  color: #1c449c;
}

.form-check-input:checked {
  background-color: var(--radio--background-color) !important;
  border-color: var(--radio--border-color) !important;
}

.tooltip-inner {
  background-color: #fff !important;
  color: #000 !important;
  border: 1px solid rgba(140, 143, 149, 0.5019607843) !important;
  max-width: 500px !important;
  width: 300px !important;
  font-size: 16px !important;
  text-align: left !important;
  box-shadow: 0px 0px 3px 0px gray;
}
.tooltip-inner p {
  margin-top: 0;
  margin-bottom: 0;
}
.tooltip-inner .itemName {
  font-size: 16px;
  font-weight: 600;
}
.tooltip-inner .textPros {
  font-size: 12px;
  font-weight: 400;
  text-align: right;
}
.tooltip-inner .rowBorder {
  border-bottom: 1px dashed #858484;
}

.tooltip.show {
  opacity: initial !important;
}

.sidebar-nav .nav-heading {
  font-size: 14px;
  text-transform: uppercase;
  color: #000000;
  font-weight: 600;
  margin: 12px 0 5px 0px;
}

.accordion-button:focus {
  box-shadow: none !important;
}

.accordion-button:not(.collapsed) {
  background-color: #ffffff !important;
}

.accordion-header {
  margin-left: 0px;
  margin-right: 0px;
}

.accordion-item .headerTitle {
  display: block;
  font-size: 17px;
  font-weight: bold;
  padding-bottom: 4px;
}
.accordion-item .subHeaderTitle {
  display: block;
  font-size: 14px;
  font-weight: 400;
}

.accordion .refreshIcon {
  width: 80px;
  text-align: end;
  font-size: 20px;
  cursor: pointer;
}
.accordion .refreshIcon:hover {
  font-size: 22px;
}
.accordion .dropdown-menu.show {
  position: absolute !important;
  inset: 30px 0px auto -122px !important;
  margin: 0 !important;
  transform: translate(0, 0) !important;
}

.commonFooter {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  color: #fff;
  text-align: center;
  padding: 20px 0;
  margin-left: -2%;
}

.rowDirection {
  flex-direction: row-reverse;
}

.headerIcon {
  font-size: 18px;
  cursor: pointer;
}

.headerIcon:hover {
  color: #ceaef7;
}

.iconLogo {
  background: var(--table-icon-background-color) !important;
  font-size: 20px;
  color: var(--table-icon-text-color);
  border: 1px solid rgba(0, 0, 0, 0.11);
  border-radius: 4px;
  width: 44px;
  display: block;
  padding: 5px 0px;
}

.qr-code .qr-code-navbar button {
  float: right;
  right: 10px;
}
.qr-code .card {
  margin: 10px;
}
.qr-code .card img {
  height: 140px;
  border-bottom: 1px solid #0047ab;
}
.qr-code .card .card-title {
  text-align: center;
  position: relative;
  color: #0047ab;
  font-weight: 700;
}
.qr-code .card .user-role {
  text-align: center;
  position: relative;
}
.qr-code .card .user-qr-code {
  position: relative;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
  display: table;
}

/* Ensure the table has borders and takes up the full width */
.jobcard-content-table {
  width: 100%;
  /* Ensure the table takes up the full width of its parent */
  border-collapse: collapse;
  /* Collapse borders to make it cleaner */
}

.jobcard-detail-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  /* Equal column widths */
  font-size: 13px;
}
.jobcard-detail-table th,
.jobcard-detail-table td {
  border: 2px solid #000;
  padding: 4px;
  word-wrap: break-word;
  text-align: left;
  height: 50px;
  line-height: 20px;
}
.jobcard-detail-table th:first-child,
.jobcard-detail-table td:first-child {
  width: 16%;
  /* First column gets more space */
}
.jobcard-detail-table th:not(:first-child),
.jobcard-detail-table td:not(:first-child) {
  width: 10%;
  /* Adjust based on how many columns you have */
}
.jobcard-detail-table tr:not(:first-child) {
  line-height: 30px;
}

.report-title-line {
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between;
  width: 100%;
  white-space: nowrap;
  margin-top: 5px;
}

.report-title-line > div {
  flex: 1 1;
  padding: 0;
  margin: 0;
  text-align: left;
}

.report-title-line > div:last-child {
  text-align: right;
}

.telma-header {
  text-align: center;
  text-decoration: underline;
}

.telma-detail {
  display: block;
  text-align: center;
  width: 100%;
}

.jobcard-singlerow {
  text-align: center !important;
}

.jobcard-content-table td,
.jobcard-content-table th {
  border: 2px solid #000000;
  /* Add a border to table cells */
  padding: 5px 8px;
  /* Add padding to make the content more readable */
  text-align: left;
  /* Align text to the left in table cells */
}

/* Styling for bold table content */
.jobcard-content-bold {
  font-weight: bold;
  color: #0047ab;
  /* Optional: Add color for bold content */
}

/* Ensure the content in the second column is centered */
.jobcard-content-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

/* Card Title Styling */
.jobcard-priority {
  color: #0047ab !important;
  /* Default priority color */
  text-align: center;
  font-weight: bold !important;
}

.jobcard-priority-urgent {
  color: red !important;
  /* Priority 'urgent' color */
  text-align: center;
  font-weight: bold !important;
}

/* Styling for QR code */
.jobcard-content-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.jobcard-content-table td,
.jobcard-content-table th {
  border: 2px solid #000000;
  padding: 5px 8px;
  text-align: left;
}

.jobcard-content-bold {
  font-weight: bold;
  color: #0047ab;
}

.qr-code-cell {
  width: 120px;
  /* Set width for the QR code cell */
  text-align: center;
  /* Center the QR code inside the cell */
}

.jobcard-qr-code {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 5px;
}

.jobcard-qr-code img {
  width: 100%;
  height: auto;
}

.jobcard-title-content {
  text-align: center !important;
  font-weight: bold;
  color: #0047ab;
  margin-bottom: 2px;
}

.jobcard-title-content-jobcard {
  margin-top: 10px;
  text-align: center !important;
  font-weight: bold;
  color: #0047ab;
}

input[type=text],
input[type=number],
input[type=date],
input[type=password],
input[type=email],
.rw-widget-picker {
  background-color: rgba(255, 255, 255, 0.8901960784) !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  height: 42px;
  border: var(--bs-border-width) solid var(--bs-border-color);
}

input[type=checkbox] {
  height: 20px;
  width: 20px;
  border: 1px solid #B8B8B8 !important;
}

input[type=number]:disabled {
  background: #e8e8e8 !important;
  font-weight: 600;
  color: var(--textbox-disabled-text-color);
}

h1,
h2,
h3,
h4,
h5,
h6,
p,
span,
label,
a,
div {
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
  color: var(--app-text-color);
}

.is-invalid .rw-widget-picker {
  border: 1px solid var(--bs-form-invalid-border-color) !important;
}

.dropdownHive input[type=text] {
  border-radius: 2px !important;
  font-size: 14px !important;
  border: 0px solid rgb(195, 185, 185) !important;
}
.dropdownHive .rw-widget-picker {
  min-height: 42px;
  border-radius: 8px;
}
.dropdownHive .rw-list-option.rw-state-selected,
.dropdownHive .rw-state-selected.rw-list-option-create {
  background-color: #aaa8a8;
  border-color: #aaa8a8;
  color: #fff;
}

.dropdownHiveOption {
  z-index: 9999;
}

.jobcardYearPicker {
  width: 100%;
}

.jobcardYearPickerControl {
  align-items: center;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  display: flex;
  min-height: 42px;
  overflow: hidden;
  width: 100%;
}
.jobcardYearPickerControl input {
  background: transparent;
  border: 0;
  cursor: pointer;
  flex: 1 1;
  font-size: 14px;
  min-width: 0;
  outline: 0;
  padding: 0 12px;
}
.jobcardYearPickerControl button {
  align-items: center;
  align-self: stretch;
  background: transparent;
  border: 0;
  color: #657482;
  display: flex;
  justify-content: center;
  padding: 0 12px;
}

.dropdownIcon {
  top: 23px;
}

.form-label {
  font-weight: 600;
  font-size: 14px;
}

a {
  text-decoration: none !important;
}

.subText {
  font-size: 14px;
}

.form-signin {
  text-align: center;
  margin-top: 22px;
  font-size: 16px;
  font-weight: 600;
}

.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(79, 70, 229, var(--tw-text-opacity)) !important;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #bec4c4;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* ===== Scrollbar CSS ===== */
/* Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: #bebbbb #ffffff;
}

/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 16px;
}

*::-webkit-scrollbar-track {
  background: #ffffff;
}

*::-webkit-scrollbar-thumb {
  background-color: #bebbbb;
  border-radius: 10px;
  border: 3px solid #ffffff;
}

.arrowBtn {
  width: 50px !important;
}

.logoBtn {
  width: 70px !important;
}

.headerText {
  font-weight: 600;
  font-size: 16px;
  margin-right: 4px;
  display: block;
}

.headerSubText {
  font-size: 16px;
}

.deleteIconAccordion {
  float: inline-end;
  margin-top: -40px;
}
.deleteIconAccordion i {
  font-size: 24px;
  color: red;
  cursor: pointer;
}
.deleteIconAccordion i:hover {
  font-size: 26px;
}

.infoIconAccordion i {
  font-size: 18px;
  color: rgb(24, 33, 121);
  cursor: pointer;
}

.dynamicDropdown .rw-popup-container {
  padding: 0px !important;
  position: static !important;
}

.numberFormate {
  width: 100%;
  text-align: end;
}

.sectionArea {
  box-shadow: 0px 20px 40px 9px rgba(0, 0, 0, 0.295);
}

.navMenu {
  font-weight: 400 !important;
  text-transform: uppercase;
}

.supplier_app {
  font-family: sans-serif, "Helvetica Neue", "Lucida Grande", Arial;
  font-size: 34px;
}

.feature .learnMore {
  padding: 7px;
  background: #ff3434;
  color: #ffffff;
  font-weight: 600;
  letter-spacing: 1px;
}
.feature .textBox {
  border-left-width: 18px;
  height: 325px;
  padding-top: 35px;
  margin-right: 7%;
  padding-left: 38px;
  text-align: justify;
}

.h2 {
  margin-top: 0;
  margin-bottom: 25px;
  font-size: 60px;
  line-height: 120%;
  color: #e3f2ff;
}
.h2 .headline-emphasis-red {
  color: #e04b4d;
  font-family: Georgia, Times, Times New Roman, serif;
  font-style: italic;
  font-weight: 400;
}

.cta {
  margin-top: 0;
  margin-bottom: 25px;
  font-size: 40px;
  line-height: 120%;
}
.cta .headline-emphasis-gold {
  color: #c4a27f;
  font-family: Georgia, Times, Times New Roman, serif;
  font-style: italic;
  font-weight: 400;
}

.staffed {
  margin-top: 0;
  margin-bottom: 25px;
  font-size: 45px;
  line-height: 160%;
  color: #410641;
}

.ctaFindButton {
  background-color: rgba(251, 0, 0, 0.6117647059) !important;
}

.ctaFindButton:hover {
  background-color: #ff0000 !important;
}

.text-lgColor {
  color: #71b7b7;
}

.text-xlColor {
  color: #f7f7f7;
}

.footer .workersHiveFooter {
  text-align: right;
  position: absolute;
  padding-top: 1%;
}

.navBackground {
  background-color: #131834;
}

.loginPage {
  background-color: #ffffff;
  background-image: -webkit-linear-gradient(278deg, #f3f3f3 65%, #ffffff 50%);
}
.loginPage .loadSingIn {
  animation: bounce-in 1s ease-in;
}
.loginPage .loadReset {
  animation: bounce-out 1s ease-in;
}
@keyframes bounce-in {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes bounce-out {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.5);
  }
}
.loginPage .indexValue {
  z-index: 5;
}
.loginPage .mainTitle {
  font-weight: 700;
  letter-spacing: 1px;
  margin-bottom: 18px;
  margin-top: 15px;
  color: #dc0000;
  text-align: center;
}
.loginPage .box2 {
  border: 1px solid #dbd6d6;
  border-radius: 3px;
  box-shadow: 0px 7px 20px 3px #b7b6b6;
  padding: 40px 40px 30px 40px;
}
.loginPage .box2 .inputBox {
  padding-left: 10px;
}
.loginPage .box2 .eyeCss {
  margin-top: 12px;
  width: 30px;
}
.loginPage .box2 .mainTitleBox2 {
  font-size: 20px;
  color: #313131;
  margin-top: 6px;
}
.loginPage .box2 .passwordEye {
  position: absolute;
  margin-left: -28px;
  margin-top: 18px;
}
.loginPage .footer {
  margin-top: 0%;
  float: left;
  font-size: 14px;
  font-weight: 600;
}
.loginPage .footer .footerLink {
  text-decoration: none;
  color: #2b2a2a;
  margin-right: 14px;
}
.loginPage .footer .footerLinkText {
  margin: 8px 13px 13px 2px;
  font-size: 12px;
  font-weight: 500;
}
.loginPage .subText {
  font-size: 13px;
}
.loginPage .staySingIn {
  font-size: 14px;
  font-weight: 600;
}
.loginPage .removeUnderline {
  cursor: pointer;
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
  color: #0d6efd;
  float: right;
  margin-top: -21px;
}
.loginPage .removeUnderline:hover {
  color: rgb(220, 0, 0);
}
.loginPage .singUp {
  cursor: pointer;
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
  color: #0d6efd;
}
.loginPage .singUp:hover {
  color: rgb(220, 0, 0);
}
.loginPage .returnSingIn {
  cursor: pointer;
  text-align: center;
  margin-top: 25px;
  font-size: 14px;
  font-weight: 600;
  color: #0d6efd;
}
.loginPage .returnSingIn:hover {
  color: rgb(220, 0, 0);
}
.loginPage .db-RegisterAndLoginBackground-background {
  z-index: 0;
  position: absolute;
  top: 530px;
  bottom: 0;
  left: 0;
  right: 0;
  transform: skewY(352deg);
}
.loginPage .db-RegisterAndLoginBackground-background .db-RegisterAndLoginBackground-firstLeftStripe {
  background: rgba(220, 0, 0, 0.78);
  height: 40px;
  top: 668px;
  left: calc(50% - 700px);
  right: calc(50% + 540px);
}
.loginPage .db-RegisterAndLoginBackground-background .db-RegisterAndLoginBackground-secondLeftStripe {
  background: rgba(13, 0, 255, 0.37);
  height: 16px;
  top: 698px;
  left: -10px;
  right: calc(50% + 405px);
}

.login-username input {
  border-radius: 2px !important;
  height: 50px;
}

.mailConfirmation .confirmIcon {
  font-size: 100px;
  position: absolute;
  color: #00d700;
  margin-top: -56px;
  margin-left: -42px;
}
.mailConfirmation .mainTitle {
  font-weight: 700;
  letter-spacing: 1px;
  margin-bottom: 18px;
  margin-top: 15px;
  color: #dc0000;
  text-align: center;
}
.mailConfirmation .box2 {
  border: 1px solid #dbd6d6;
  border-radius: 3px;
  box-shadow: 0px 7px 20px 3px #b7b6b6;
  padding: 90px 40px 30px 40px !important;
}
.mailConfirmation .box2 .mainContent {
  text-align: center;
  font-size: 26px;
  font-weight: bold;
}
.mailConfirmation .box2 .subContent {
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 32px;
}
.mailConfirmation .box2 .inputBox {
  padding-left: 10px;
}
.mailConfirmation .box2 .eyeCss {
  margin-top: 12px;
  width: 30px;
}
.mailConfirmation .box2 .mainTitleBox2 {
  font-size: 20px;
  color: #313131;
  margin-top: 6px;
}
.mailConfirmation .box2 .passwordEye {
  position: absolute;
  margin-left: -28px;
  margin-top: 18px;
}
.mailConfirmation .footer {
  margin-top: 30px;
  float: left;
  font-size: 14px;
  font-weight: 600;
}
.mailConfirmation .footer .footerLink {
  text-decoration: none;
  color: #2b2a2a;
  margin-right: 14px;
}
.mailConfirmation .footer .footerLinkText {
  margin: 8px 13px 13px 2px;
  font-size: 12px;
  font-weight: 500;
}
.mailConfirmation .db-RegisterAndLoginBackground-background {
  z-index: 0;
  position: absolute;
  top: 530px;
  bottom: 0;
  left: 0;
  right: 0;
  transform: skewY(352deg);
}
.mailConfirmation .db-RegisterAndLoginBackground-background .db-RegisterAndLoginBackground-firstLeftStripe {
  background: rgba(220, 0, 0, 0.78);
  height: 40px;
  top: 668px;
  left: calc(50% - 700px);
  right: calc(50% + 540px);
}
.mailConfirmation .db-RegisterAndLoginBackground-background .db-RegisterAndLoginBackground-secondLeftStripe {
  background: rgba(13, 0, 255, 0.37);
  height: 16px;
  top: 698px;
  left: -10px;
  right: calc(50% + 405px);
}

.registerPage .fieldErrMsg {
  font-size: 12px;
  color: #f32525 !important;
}
.registerPage .indexValue {
  z-index: 5;
}
.registerPage .logo {
  width: 150px;
}
.registerPage .mainTitle {
  font-weight: 700;
  letter-spacing: 1px;
  margin-bottom: 30px;
  margin-top: -36px;
}
.registerPage .mainTitleSm {
  font-weight: 700;
  letter-spacing: 1px;
  margin-bottom: 32px;
  margin-top: 40px;
  color: #dc0000;
  text-align: center;
}
.registerPage .box1 .boxTitle {
  font-size: 16px;
  font-weight: 600;
  margin-top: 7px;
}
.registerPage .box1 .subBoxTitle {
  font-size: 14px;
  font-weight: 500;
}
.registerPage .box2 {
  border: 1px solid #dbd6d6;
  border-radius: 3px;
  box-shadow: 0px 7px 20px 3px #b7b6b6;
  padding: 40px 40px 30px 40px;
}
.registerPage .box2 .inputBox {
  padding-left: 10px;
}
.registerPage .box2 .eyeCss {
  margin-top: 12px;
  width: 30px;
}
.registerPage .box2 .mainTitleBox2 {
  color: #313131;
  margin-top: 6px;
}
.registerPage .footer {
  margin-top: 12%;
  float: left;
  font-size: 14px;
  font-weight: 600;
}
.registerPage .footer .footerLink {
  text-decoration: none;
  color: #2b2a2a;
  margin: 13px;
}
.registerPage .footer .footerLinkText {
  margin: 3px 13px 13px 15px;
  font-size: 12px;
  font-weight: 500;
}
.registerPage .singIn {
  text-decoration: none;
}
.registerPage .db-RegisterAndLoginBackground-background {
  z-index: 0;
  position: absolute;
  top: 530px;
  bottom: 0;
  left: 0;
  right: 0;
  transform: skewY(352deg);
}
.registerPage .db-RegisterAndLoginBackground-background .db-RegisterAndLoginBackground-firstLeftStripe {
  background: rgba(220, 0, 0, 0.78);
  height: 40px;
  top: 668px;
  left: calc(50% - 700px);
  right: calc(50% + 540px);
}
.registerPage .db-RegisterAndLoginBackground-background .db-RegisterAndLoginBackground-secondLeftStripe {
  background: rgba(13, 0, 255, 0.37);
  height: 16px;
  top: 698px;
  left: -10px;
  right: calc(50% + 405px);
}

.status-col-wrapper {
  width: 100%;
  max-width: 500px;
  /* Adjust as needed */
  height: 92rem;
  /* Adjust height to show about 6 cards */
  overflow: hidden;
  margin: 0 auto;
  border-radius: 16px;
  box-shadow: 0 2px 8px 0 rgba(80, 120, 180, 0.04);
  background: #fff;
}

.status-col {
  display: flex;
  flex-direction: column;
  gap: 0px;
  animation: scroll-up 16s linear infinite;
}

.status-col:hover {
  animation-play-state: paused;
}

/* Adjust the -50% based on card count/height! */
@keyframes scroll-up {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-10%);
  }
}
.machine-overview-card {
  margin: 20px;
  padding: 0px !important;
  box-shadow: 0 2px 8px 0 rgba(80, 120, 180, 0.08);
  border-radius: 16px;
  margin-bottom: 0;
}
.machine-overview-card .card-body {
  padding: 10px;
  border: 1px solid rgba(0, 35, 135, 0.168627451);
  border-radius: 4px;
}
.machine-overview-card .status-row {
  display: flex;
  gap: 7px;
  flex-wrap: wrap;
  align-items: center;
  font-size: 17px;
}
.machine-overview-card .chip {
  display: inline-flex;
  align-items: center;
  padding: 0.3em 1em;
  border-radius: 2em;
  font-weight: 500;
  background: #f2f4f8;
  color: #333;
  box-shadow: 0 2px 8px 0 rgba(80, 120, 180, 0.04);
  transition: background 0.2s;
}
.machine-overview-card .chip-blue {
  background: rgba(0, 36, 135, 0.231372549);
  color: #002387;
}
.machine-overview-card .chip-green {
  background: rgba(34, 139, 34, 0.231372549);
  color: #008000;
}
.machine-overview-card .chip-red {
  background: rgba(243, 14, 45, 0.231372549);
  color: #f30e2d;
}
.machine-overview-card .chip-orange {
  color: #ac7603;
  background-color: rgba(255, 191, 0, 0.2666666667);
}

.monthly-overview-wrapper {
  border: 1px solid #ddd;
  margin-bottom: 12px;
  margin-right: 10px;
  font-size: 20px;
}

.monthly-overview-header {
  cursor: pointer;
  padding: 10px 15px;
  background: #f7f7f7;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.toggle-arrow {
  transition: transform 0.25s ease-in-out;
}

.toggle-arrow.open {
  transform: rotate(180deg);
}

.monthly-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.35s ease;
}

.monthly-content.show {
  max-height: 600px;
  /* large enough height */
  padding: 10px 15px;
}

.section-title {
  font-weight: 700;
  margin-bottom: 20px;
  color: #444;
}

.monthly-column {
  padding: 10px 15px;
}
.monthly-column .block {
  background: white;
  border-radius: 6px;
  border: 1px solid #dcdcdc;
  padding: 15px 20px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);
  margin: 0px 4px !important;
}
.monthly-column .block-header {
  padding: 6px 10px;
  border-radius: 4px;
  font-weight: 600;
  margin-bottom: 10px;
  text-transform: uppercase;
  font-size: 13px;
}
.monthly-column .block-item {
  display: flex;
  justify-content: space-between;
  padding: 4px 0px;
  border-bottom: 1px dashed #dedede;
  font-size: 14px;
}
.monthly-column .block-item:last-child {
  border-bottom: none;
}
.monthly-column .block-item label {
  color: #444;
  font-weight: 500;
}
.monthly-column .block-item span {
  color: #000;
  font-weight: 600;
}

.urgent-color {
  background: rgba(243, 14, 45, 0.231372549);
  color: #f30e2d;
}

.regular-color {
  background: #e7efff;
  color: #1155cc;
}

.overview-card {
  margin: 10px 10px 0 10px;
  border-radius: 5px !important;
}
.overview-card .card-header {
  background-color: var(--header-background-color) !important;
  color: #FFFFFF;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.overview-card .card-body {
  padding: 10px !important;
}
.overview-card .overview-card {
  padding: 10px;
  border-radius: 8px;
}
.overview-card .column-card-heading {
  display: block;
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 10px;
}
.overview-card .detail-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
  font-size: 14px;
}
.overview-card .left-section {
  border-right: 1px solid #ddd;
  padding-right: 20px;
}
.overview-card .right-section {
  padding-left: 20px;
}
.overview-card .dates {
  border: 1px solid #ebeff2;
  border-radius: 5px;
  padding: 10px 0px;
  margin: 10px 10px;
  font-size: 16px;
  color: #5aadef;
  font-weight: 700;
  overflow: auto;
}
.overview-card .dates .urgent {
  font-size: 30px;
  color: #0d6efd;
  cursor: pointer;
}
.overview-card .dates .machines-urgent {
  font-size: 20px;
  color: #0d6efd;
}
.overview-card .dates .regular {
  font-size: 30px;
  color: #00d700;
  cursor: pointer;
}
.overview-card .dates div {
  float: left;
  width: 50%;
  text-align: center;
  position: relative;
}
.overview-card .dates .machines-urgent {
  float: left;
  width: 100%;
  text-align: center;
  position: relative;
}
.overview-card .dates strong,
.overview-card .stats strong {
  display: block;
  color: #adb8c2;
  font-size: 11px;
  font-weight: 700;
}
.overview-card .dates span {
  width: 1px;
  height: 40px;
  position: absolute;
  right: 0;
  top: 0;
  background: #ebeff2;
}
.overview-card .column-card-heading {
  display: block;
  color: #adb8c2;
  font-size: 11px;
  font-weight: 700;
  text-align: center;
}
.overview-card .overview-footer strong,
.overview-card .stats strong {
  display: block;
  color: #adb8c2;
  font-size: 11px;
  font-weight: 700;
}
.overview-card .overview-footer div {
  float: left;
  text-align: center;
  position: relative;
  font-size: 20px;
  font-weight: 700;
}
.overview-card .machine-overview-footer div {
  float: left;
  text-align: center;
  position: relative;
  font-size: 14px;
  font-weight: 700;
}
.overview-card .machine-overview-footer strong,
.overview-card .stats strong {
  display: block;
  color: #adb8c2;
  font-size: 11px;
  font-weight: 700;
}
.overview-card .reject-quantity {
  color: red;
}
.overview-card .overview-card-header-value {
  float: right;
  color: #FFFFFF;
  cursor: pointer;
}
.overview-card .success-indicator {
  float: right;
  filter: drop-shadow(0 0 10px #24ff41) drop-shadow(0 0 30px #0aef2d) drop-shadow(0 0 50px #40e911);
  background-color: rgb(0, 254, 136) !important;
}
.overview-card .error-indicator {
  float: right;
  filter: drop-shadow(0 0 5px #ff9898) drop-shadow(0 0 5px #fc8b8b) drop-shadow(0 0 5px #ff5b5b);
  background-color: #ff0707;
  animation: glow 1s infinite alternate;
}
@keyframes glow {
  0% {
    box-shadow: 0 0 10px red;
  }
  100% {
    box-shadow: 0 0 20px red, 0 0 30px red;
    /* More glow */
  }
}

.searchDropdown {
  width: 400px;
}

.jobcard-div {
  display: flex;
  padding: 10px;
  border-radius: 5px;
}

.machineStatus-card {
  margin: 20px;
  border-radius: 5px !important;
  color: #009845 !important;
  font-weight: bold;
  cursor: pointer;
}
.machineStatus-card .active {
  font-size: 20px;
  color: #009845 !important;
  border: 2px solid #009845;
  border-radius: 5px;
}
.machineStatus-card .active .machineStatus-text {
  color: #009845 !important;
  width: 22em;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.machineStatus-card .active .label {
  color: #009845 !important;
  font-weight: bold;
}
.machineStatus-card .card-body:hover {
  background-color: rgba(119, 167, 238, 0.3019607843);
}
.machineStatus-card .in-active {
  font-size: 20px;
  border: 2px solid #f30e2d;
  border-radius: 5px;
  background-color: rgba(255, 4, 4, 0.2392156863);
}
.machineStatus-card .in-active .machineStatus-text {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 22em;
  color: #f30e2d !important;
}
.machineStatus-card .in-active .label {
  color: #f30e2d !important;
  font-weight: bold;
}

.machine-status-form {
  font-size: 26px;
}
.machine-status-form .form-check-label {
  font-size: 16px;
  padding-top: 6px;
}
.machine-status-form .form-check-input {
  border: 1px solid #000000 !important;
}

.back {
  color: #FFFFFF;
}

.machineStatusTitle {
  font-weight: 700;
  letter-spacing: 1px;
  margin-top: 10px;
  margin-left: 36%;
  margin-right: 32%;
}

.reworkStatusTitle {
  font-weight: 700;
  letter-spacing: 1px;
  margin-top: 10px;
  margin-left: 46%;
  margin-right: 32%;
}

.submsgTitle {
  font-weight: 500;
  letter-spacing: 1px;
  margin-top: 10px;
  margin-left: 40%;
}

.acknowledmentStatus {
  width: 16%;
  float: right;
  position: absolute;
  top: 13px;
  left: 82%;
}

.navigateBackButton {
  float: left;
}

.machineIdleHeading {
  display: flex;
  justify-content: center;
  align-Items: center;
}

.machineIdleLabel {
  font-weight: 500;
  font-size: 18px;
}

.machine-status-footer-button .btn {
  margin-right: 50px !important;
  border-radius: 0px !important;
}

.machineIdleColumn {
  padding: 10px;
}

.machineIdleRadio .form-check-label {
  font-weight: 400;
}
.machineIdleRadio .checkListType {
  background-color: var(--header-background-color) !important;
  color: #FFFFFF;
  align-items: center;
  font-weight: bold;
}
.machineIdleRadio .checklistSwitch {
  width: 100% !important;
  display: table;
  margin: 1.5em;
}
.machineIdleRadio .checklistSwitch label {
  font-size: 18px;
}

.w-90 {
  width: 22em;
}

.ackQRBase {
  height: 500px;
}

.jobcard-qrscanner-modal .manual-jobcard-form label {
  padding: 6preportheaderx;
  font-size: 18px;
  font-weight: 700;
}
.jobcard-qrscanner-modal .manual-jobcard-form input {
  width: 50%;
  padding-left: 5px;
}
.jobcard-qrscanner-modal .modal-dialog .modal-footer {
  display: inline-block;
}

.ack-toMachine {
  display: flex;
}
.ack-toMachine #machineCode_input {
  width: 70%;
  margin-left: 30px;
}

.ack-card {
  margin-top: 20px !important;
}

.jobcard-detail-list span {
  font-weight: bold;
}

.start-stop-page-header {
  margin-bottom: 15px;
}

.reportheader {
  border: 1px solid #8c8686;
  border-radius: 8px;
  padding: 10px 10px 10px 10px;
  border-style: dashed;
  margin-bottom: 20px;
  background-color: #ffffff;
  box-shadow: 0px 1px 9px 1px #b7b7b7;
}

.filterbox-btn {
  align-items: center;
  display: flex;
  margin-top: 10px !important;
}
.filterbox-btn button {
  margin-left: 20px;
}

.searchFilter-btn i {
  font-size: 24px;
}

.loader-small .loader-sm {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  animation: none;
}
.loader-small .loader__circle {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  margin: 0 4px;
  animation: loader_901 1s ease-in-out infinite;
}
.loader-small .loader__circle:nth-of-type(1) {
  background-color: #007aff;
  animation-delay: 0;
}
.loader-small .loader__circle:nth-of-type(2) {
  background-color: #ff2d55;
  animation-delay: 0.25s;
}
.loader-small .loader__circle:nth-of-type(3) {
  background-color: #34c759;
  animation-delay: 0.5s;
}
.loader-small .loader__circle:nth-of-type(4) {
  background-color: #ff9500;
  animation-delay: 0.75s;
}
@keyframes loader_901 {
  0% {
    transform: scale(1);
  }
  20% {
    transform: scale(1.2);
  }
  40% {
    transform: scale(1);
  }
}

.order-conf-footer {
  padding: 0px !important;
}
.order-conf-footer button {
  width: 100% !important;
  border-radius: 0px !important;
}

.oc-header-right {
  float: right;
  text-align: right;
}
.oc-header-right .column-card-heading {
  font-size: 18px;
}

.oc-header-left .column-card-heading {
  font-size: 18px;
}

.oc-header-value {
  font-size: 22px;
  color: #858484;
}

.popupInputField input {
  width: 100px;
  padding-left: 5px;
}

.automanual {
  display: flex;
  align-items: center;
}
.automanual .form-switch input {
  height: 30px;
  width: 50px;
}
.automanual .form-check-label {
  font-size: 16px;
  padding-top: 5px;
  padding-left: 5px;
}

.jobcard-report-grid .card {
  margin: 10px;
  padding: 0px;
}
.jobcard-report-grid .card .card-body {
  margin: 0px;
  padding: 0px;
}

.center-header {
  text-align: center;
}

.marque-card {
  padding: 0px;
  min-height: 60px;
}
.marque-card .card-body {
  padding: 5px;
}

.border-right-column {
  border-right: 4px solid #0070bb;
}

.circle-overlay {
  position: absolute;
  /* use 'relative' on the parent if needed */
  top: 10px;
  right: 10px;
  width: 50px;
  height: 50px;
  background-color: rgba(0, 123, 255, 0.3490196078);
  /* Bootstrap primary blue */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  z-index: 999;
  transition: all 0.3s ease;
}
.circle-overlay i {
  font-size: 26px;
}

.circle-overlay:hover {
  background-color: #0056b3;
  /* Darker on hover */
}

.pvtTable {
  display: block;
  max-width: 103vw;
  /* max width is 90% of viewport width */
  max-height: 70vh;
  /* max height is 70% of viewport height */
  overflow: auto;
  border: 1px solid #ccc;
  margin: 0 auto;
  min-width: 600px;
  /* optional to force min horizontal scroll */
}

.pvtUi {
  width: 100%;
}

.pvtOutput {
  width: 100%;
}

.pvtTotal {
  display: none;
}

.pvtTotalLabel {
  display: none;
}

.pvtGrandTotal {
  display: none;
}

.pvtVals {
  visibility: hidden !important;
}

.pvtAggregator {
  visibility: hidden !important;
}

table.pvtTable thead tr th,
table.pvtTable tbody tr th {
  border: 1px solid #0047ab !important;
}

table.pvtTable tbody tr td {
  border: 1px solid #0047ab !important;
}

/* Responsive tweaks */
@media (max-width: 768px) {
  .pvtTable {
    max-width: 100vw;
    max-height: 60vh;
    min-width: 500px;
  }
}
/* Landscape tablets approx width between 768px and 1024px */
@media (min-width: 769px) and (max-width: 1024px) {
  .pvtTable {
    max-width: 100vw;
    /* cap at viewport width */
    max-height: 65vh;
    min-width: 500px;
    /* moderate min-width */
  }
}
@media (min-width: 1200px) {
  .pvtTable {
    width: 103vw;
    max-height: 75vh;
    min-width: 900px;
  }
}
.pvtAxisContainer,
.pvtVals {
  background-color: #FFFFFF !important;
}

/* 3D tower loader made by: csozi | Website: www.csozi.hu*/
.dots-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  margin-top: 150px;
}

.dot {
  height: 20px;
  width: 20px;
  margin-right: 10px;
  border-radius: 10px;
  background-color: #b3d4fc;
  animation: pulse 1.5s infinite ease-in-out;
}

.dot:last-child {
  margin-right: 0;
}

.dot:nth-child(1) {
  animation-delay: -0.3s;
}

.dot:nth-child(2) {
  animation-delay: -0.1s;
}

.dot:nth-child(3) {
  animation-delay: 0.1s;
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
    background-color: #b3d4fc;
    box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);
  }
  50% {
    transform: scale(1.2);
    background-color: #6793fb;
    box-shadow: 0 0 0 10px rgba(178, 212, 252, 0);
  }
  100% {
    transform: scale(0.8);
    background-color: #b3d4fc;
    box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);
  }
}
/* === Modern Card Styling === */
.modern-card {
  background: rgba(255, 255, 255, 0.85);
  border-radius: 15px;
  padding: 10px 10px;
  text-align: center;
  cursor: pointer;
  transition: all 0.4s ease;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.modern-card:hover {
  transform: translateY(-6px) scale(1.03);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

/* === Icon Styling === */
.modern-card .icon-wrapper {
  background: linear-gradient(135deg, #6c5ce7, #a29bfe);
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 15px auto;
  font-size: 1.5rem;
  color: #fff;
  transition: all 0.3s ease;
}

.modern-card:hover .icon-wrapper {
  background: linear-gradient(135deg, #74b9ff, #a29bfe);
}

/* === Card Text === */
.modern-card h5 {
  font-weight: 600;
  margin-bottom: 5px;
  font-size: 1.2rem;
}

.modern-card p {
  color: #636e72;
  font-size: 0.9rem;
}

/* === Section Headers === */
.menu-section h3 {
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 20px;
  padding-left: 10px;
  border-left: 5px solid;
}

.masters h3 {
  border-color: #0047ab;
  color: #0047ab;
}

.reports h3 {
  border-color: #f68134;
  color: #f68134;
}

.transactions h3 {
  border-color: #f68134;
  color: #f68134;
}

/* === Page Title Styling === */
.mainTitle {
  font-size: 1.8rem;
  font-weight: 700;
}

.subText {
  color: #636e72;
  margin-bottom: 20px;
}

.filterIcon {
  font-size: 45px;
  justify-content: flex-end;
  display: flex;
  color: #008ffb;
  cursor: pointer;
}

.filterIcon:hover {
  color: #031422;
}

.filterBox {
  border: 1px solid #8c8686;
  border-radius: 8px;
  padding: 18px 16px 0px 16px;
  border-style: dashed;
  margin-bottom: 20px;
  background-color: #ffffff;
  box-shadow: 0px 1px 9px 1px #b7b7b7;
}

.dashboard-navigate-icon {
  font-size: 32px;
  position: absolute;
  top: 96px;
  right: 10px;
  color: #3457D5;
  cursor: pointer;
}

.dashboard-navigate-icon:hover {
  color: #318CE7;
}

.loader-small .loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}
.loader-small .loader__circle {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  margin: 0 4px;
  animation: loader_901 1s ease-in-out infinite;
}
.loader-small .loader__circle:nth-of-type(1) {
  background-color: #007aff;
  animation-delay: 0;
}
.loader-small .loader__circle:nth-of-type(2) {
  background-color: #ff2d55;
  animation-delay: 0.25s;
}
.loader-small .loader__circle:nth-of-type(3) {
  background-color: #34c759;
  animation-delay: 0.5s;
}
.loader-small .loader__circle:nth-of-type(4) {
  background-color: #ff9500;
  animation-delay: 0.75s;
}
@keyframes loader_901 {
  0% {
    transform: scale(1);
  }
  20% {
    transform: scale(1.2);
  }
  40% {
    transform: scale(1);
  }
}

/* OEE Dashboard - Department stats grid */
.dept-stats {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

/* Small glossy cards */
.stat-mini {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 12px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid #eef2f7;
  box-shadow: 0 2px 6px rgba(16, 24, 40, 0.06);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.stat-mini:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 14px rgba(16, 24, 40, 0.1);
}

/* subtle left accent by tone */
.stat-mini::before {
  content: "";
  width: 4px;
  align-self: stretch;
  border-radius: 8px;
  background: #e5e7eb;
  /* default */
}

.stat-default::before {
  background: #d8dee9;
}

.stat-info::before {
  background: #cfe8ff;
}

/* Produced */
.stat-danger::before {
  background: #ffd6d6;
}

/* Rejected */
/* icon circle */
.stat-icon {
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  border-radius: 999px;
  background: #ffffff;
  border: 1px solid #edf1f7;
  font-size: 18px;
}

/* text */
.stat-body {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}

.stat-label {
  font-size: 12px;
  color: #6b7280;
  /* muted */
  margin-bottom: 6px;
}

.stat-value {
  display: flex;
  align-items: baseline;
  gap: 6px;
}

.stat-number {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  letter-spacing: 0.2px;
  font-variant-numeric: tabular-nums;
}

.stat-unit {
  font-size: 12px;
  color: #6b7280;
}

/* responsive: on small screens, 1 column */
@media (max-width: 480px) {
  .dept-stats {
    grid-template-columns: 1fr;
  }
}
/* OEE Department header styling */
.dept-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  padding: 14px 0;
  border-radius: 12px 12px 0 0;
  box-shadow: 0 3px 10px rgba(79, 70, 229, 0.2);
  position: relative;
  text-align: center;
}

.dept-header::after {
  content: "";
  position: absolute;
  bottom: -4px;
  width: 50%;
  height: 4px;
  background: linear-gradient(90deg, #162435, #a78bfa);
  border-radius: 2px;
}

.dept-badge {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
}

.dept-title {
  font-size: 12px;
  margin-top: 4px;
  color: #000000;
  letter-spacing: 0.3px;
}

.section-header {
  text-align: center;
  margin: 40px 0 20px 0;
  position: relative;
}

/* Section header Gradient text with shadow */
.section-header h4 {
  display: inline-block;
  font-size: 24px;
  font-weight: 700;
  color: #000000;
  /* Indigo tone */
  letter-spacing: 0.5px;
  background: linear-gradient(90deg, #000000, #020202);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.section-line {
  width: 180px;
  height: 4px;
  margin: 8px auto 0;
  border-radius: 4px;
  background: linear-gradient(90deg, #6366f1, #a78bfa);
  box-shadow: 0 2px 8px rgba(79, 70, 229, 0.3);
}

.progress-bar {
  transition: width 0.4s ease-in-out;
}

.progress {
  background-color: #e5e7eb !important;
  border-radius: 8px;
}

.app-footer {
  background-color: #0b2c64;
  /* same blue as your theme */
  color: #ffffff;
  font-size: 0.85rem;
  padding: 10px 30px;
  width: 100%;
  position: fixed;
  /* or relative if you don’t want it always visible */
  bottom: 0;
  left: 0;
  z-index: 100;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.footer-left,
.footer-right {
  display: flex;
  align-items: center;
  gap: 6px;
}

.footer-right a {
  color: #fff;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.footer-right a:hover {
  text-decoration: underline;
}

.dev-logo {
  height: 16px;
  vertical-align: middle;
  filter: brightness(0) invert(1);
  /* makes sure it’s visible on dark background */
}

@media (max-width: 600px) {
  .footer-content {
    flex-direction: column;
    text-align: center;
    gap: 4px;
  }
}
.printQCLabel {
  width: "16rem" !important;
  margin: 0 !important;
  /* remove bootstrap card margin */
}
.printQCLabel .card-body {
  padding: 5px;
}
.printQCLabel .card-title {
  font-size: 14px !important;
  text-align: center;
  font-weight: bold;
}
.printQCLabel .card-subtitle {
  font-size: 15px;
  text-align: center;
  font-weight: bold;
  padding-top: 3px;
}
.printQCLabel .label-size-name {
  font-size: 12px;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 20px;
  /* space between cards horizontally */
  row-gap: 10px;
}

.config-icon .nav-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.config-icon .nav-icon i {
  font-size: 1.5rem;
  color: #a3e635;
  cursor: pointer;
  transition: all 0.3s ease;
  text-shadow: 0 0 6px rgba(163, 230, 53, 0.7), 0 0 12px rgba(163, 230, 53, 0.5), 0 0 20px rgba(163, 230, 53, 0.3);
  animation: deviceGlow 2s infinite;
}
.config-icon .nav-icon i:hover {
  color: #bef264;
  transform: scale(1.15);
}

@keyframes deviceGlow {
  0% {
    text-shadow: 0 0 5px rgba(163, 230, 53, 0.5), 0 0 10px rgba(163, 230, 53, 0.3);
  }
  50% {
    text-shadow: 0 0 10px rgb(163, 230, 53), 0 0 20px rgba(163, 230, 53, 0.8), 0 0 30px rgba(163, 230, 53, 0.6);
  }
  100% {
    text-shadow: 0 0 5px rgba(163, 230, 53, 0.5), 0 0 10px rgba(163, 230, 53, 0.3);
  }
}
.device-not-configured {
  display: inline-block;
  padding: 8px 14px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 20px;
  color: #fff;
  background: linear-gradient(270deg, #ff416c, #ff4b2b, #ff416c);
  background-size: 300% 300%;
  animation: dangerGlow 3s ease infinite;
  box-shadow: 0 4px 15px rgba(255, 75, 43, 0.4);
  width: 100%;
  text-align: center;
  margin: 100px 0px;
}

@keyframes dangerGlow {
  0% {
    background-position: 0% 50%;
    transform: scale(1);
  }
  50% {
    background-position: 100% 50%;
    transform: scale(1.03);
  }
  100% {
    background-position: 0% 50%;
    transform: scale(1);
  }
}
.device-code {
  display: inline-block;
  padding: 8px 14px;
  border-radius: 12px;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(135deg, #3a4892, #544dd1);
  box-shadow: 0px 5px 12px rgba(39, 49, 103, 0.74);
  width: 100%;
  text-align: center;
}

.pin-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pin-container {
  display: flex;
  gap: 4px;
}

.pin-digit {
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  color: #000000;
  border-radius: 4px;
  border: 1px solid #222;
  font-size: 16px;
  font-weight: 700;
  font-family: monospace;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.pin-digit-hidden {
  font-size: 24px;
}

.pin-toggle-btn {
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
}
.pin-toggle-btn i {
  font-size: 18px;
  color: #555;
  transition: 0.2s ease;
}
.pin-toggle-btn:hover i {
  color: #000;
}

.OrderConfirmation .consumption-scroll {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 8px;
  scroll-behavior: smooth;
  white-space: nowrap;
}
.OrderConfirmation .consumption-scroll::-webkit-scrollbar {
  height: 6px;
}
.OrderConfirmation .consumption-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}
.OrderConfirmation .consumption-scroll::-webkit-scrollbar-thumb {
  background: #bdbdbd;
  border-radius: 10px;
}
.OrderConfirmation .consumption-scroll::-webkit-scrollbar-thumb:hover {
  background: #999;
}
.OrderConfirmation .consumption-mini-card {
  flex: 0 0 240px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  background: #fff;
  border: 1px solid #e9ecef;
  border-left: 4px solid #0d6efd;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}
.OrderConfirmation .consumption-left {
  flex: 1 1;
  min-width: 0;
}
.OrderConfirmation .consumption-type {
  font-size: 15px;
  font-weight: 700;
  color: #0d6efd;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.OrderConfirmation .consumption-size {
  font-size: 14px;
  color: #6c757d;
  margin-top: 4px;
}
.OrderConfirmation .consumption-right {
  text-align: center;
  margin-left: 12px;
}
.OrderConfirmation .qty-label {
  font-size: 10px;
  color: #6c757d;
  text-transform: uppercase;
}
.OrderConfirmation .qty-value {
  margin-top: 4px;
  min-width: 55px;
  padding: 6px 10px;
  background: #198754;
  color: #fff;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 700;
}
.OrderConfirmation .no-consumption-data {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  color: #6c757d;
  border: 1px dashed #d6d6d6;
  border-radius: 8px;
  background: #f8f9fa;
}

.jobcard-status-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 12px;
  width: 100%;
}
.jobcard-status-summary .status-card {
  width: 100%;
  padding: 6px;
  border-radius: 10px;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.jobcard-status-summary .status-card .count {
  font-size: 28px;
  font-weight: 700;
  line-height: 1;
  display: inline-block;
  animation: slideUp 0.6s ease-out;
}
.jobcard-status-summary .status-card .label {
  margin-top: 8px;
  font-size: 13px;
  font-weight: 500;
}
.jobcard-status-summary .all {
  background: #34495e;
}
.jobcard-status-summary .all .count {
  color: #ffffff;
}
.jobcard-status-summary .all .label {
  color: #ffffff;
}
.jobcard-status-summary .inprogress {
  background: rgba(255, 191, 0, 0.2666666667);
}
.jobcard-status-summary .inprogress .count {
  color: #FF8C00;
}
.jobcard-status-summary .inprogress .label {
  color: #FF8C00;
}
.jobcard-status-summary .open {
  background: rgba(0, 36, 135, 0.231372549);
}
.jobcard-status-summary .open .count {
  color: #002387;
}
.jobcard-status-summary .open .label {
  color: #002387;
}
.jobcard-status-summary .stopped {
  background: rgba(243, 14, 45, 0.231372549);
}
.jobcard-status-summary .stopped .count {
  color: #f30e2d;
}
.jobcard-status-summary .stopped .label {
  color: #f30e2d;
}
.jobcard-status-summary .ack {
  background: rgba(34, 139, 34, 0.231372549);
}
.jobcard-status-summary .ack .count {
  color: #008000;
}
.jobcard-status-summary .ack .label {
  color: #008000;
}
.jobcard-status-summary .closed {
  background: rgba(85, 85, 85, 0.137254902);
}
.jobcard-status-summary .closed .count {
  color: rgba(85, 85, 85, 0.6980392157);
}
.jobcard-status-summary .closed .label {
  color: rgba(85, 85, 85, 0.6980392157);
}
.jobcard-status-summary .complete {
  background: #273167;
}
.jobcard-status-summary .complete .count {
  color: #ffffff;
}
.jobcard-status-summary .complete .label {
  color: #ffffff;
}
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.badge-glass, .badge-chocolate, .badge-brown, .badge-dark, .badge-gray, .badge-slate, .badge-indigo, .badge-violet, .badge-purple, .badge-fuchsia, .badge-pink, .badge-rose, .badge-red, .badge-coral, .badge-deep-orange, .badge-orange, .badge-amber, .badge-yellow, .badge-lime, .badge-green, .badge-emerald, .badge-teal, .badge-cyan, .badge-sky, .badge-blue {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.3;
  letter-spacing: 0.3px;
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.25);
  transition: all 0.2s ease;
}
.badge-glass:hover, .badge-chocolate:hover, .badge-brown:hover, .badge-dark:hover, .badge-gray:hover, .badge-slate:hover, .badge-indigo:hover, .badge-violet:hover, .badge-purple:hover, .badge-fuchsia:hover, .badge-pink:hover, .badge-rose:hover, .badge-red:hover, .badge-coral:hover, .badge-deep-orange:hover, .badge-orange:hover, .badge-amber:hover, .badge-yellow:hover, .badge-lime:hover, .badge-green:hover, .badge-emerald:hover, .badge-teal:hover, .badge-cyan:hover, .badge-sky:hover, .badge-blue:hover {
  transform: translateY(-1px);
  filter: brightness(1.05);
}

/* Blue */
.badge-blue {
  background: rgba(37, 99, 235, 0.14);
  color: #2563eb;
}

/* Sky */
.badge-sky {
  background: rgba(14, 165, 233, 0.14);
  color: #0284c7;
}

/* Cyan */
.badge-cyan {
  background: rgba(6, 182, 212, 0.14);
  color: #0891b2;
}

/* Teal */
.badge-teal {
  background: rgba(20, 184, 166, 0.14);
  color: #0f766e;
}

/* Emerald */
.badge-emerald {
  background: rgba(16, 185, 129, 0.14);
  color: #059669;
}

/* Green */
.badge-green {
  background: rgba(34, 197, 94, 0.14);
  color: #15803d;
}

/* Lime */
.badge-lime {
  background: rgba(132, 204, 22, 0.16);
  color: #4d7c0f;
}

/* Yellow */
.badge-yellow {
  background: rgba(250, 204, 21, 0.18);
  color: #a16207;
}

/* Amber */
.badge-amber {
  background: rgba(245, 158, 11, 0.16);
  color: #b45309;
}

/* Orange */
.badge-orange {
  background: rgba(249, 115, 22, 0.15);
  color: #ea580c;
}

/* Deep Orange */
.badge-deep-orange {
  background: rgba(234, 88, 12, 0.15);
  color: #c2410c;
}

/* Coral */
.badge-coral {
  background: rgba(251, 113, 133, 0.15);
  color: #e11d48;
}

/* Red */
.badge-red {
  background: rgba(239, 68, 68, 0.15);
  color: #dc2626;
}

/* Rose */
.badge-rose {
  background: rgba(244, 63, 94, 0.15);
  color: #be123c;
}

/* Pink */
.badge-pink {
  background: rgba(236, 72, 153, 0.15);
  color: #db2777;
}

/* Fuchsia */
.badge-fuchsia {
  background: rgba(217, 70, 239, 0.15);
  color: #c026d3;
}

/* Purple */
.badge-purple {
  background: rgba(147, 51, 234, 0.15);
  color: #7e22ce;
}

/* Violet */
.badge-violet {
  background: rgba(139, 92, 246, 0.15);
  color: #6d28d9;
}

/* Indigo */
.badge-indigo {
  background: rgba(99, 102, 241, 0.15);
  color: #4338ca;
}

/* Slate */
.badge-slate {
  background: rgba(100, 116, 139, 0.15);
  color: #475569;
}

/* Gray */
.badge-gray {
  background: rgba(156, 163, 175, 0.18);
  color: #4b5563;
}

/* Dark */
.badge-dark {
  background: rgba(31, 41, 55, 0.12);
  color: #1f2937;
}

/* Brown */
.badge-brown {
  background: rgba(120, 53, 15, 0.12);
  color: #78350f;
}

/* Chocolate */
.badge-chocolate {
  background: rgba(146, 64, 14, 0.12);
  color: #92400e;
}`, "",{"version":3,"sources":["webpack://./src/common.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB,gBAAA;AAGA;EACE,2BAAA;AADF;;AAKA;EACE,0BAAA;AAFF;;AAKA;EACE,6BAAA;AAFF;;AAKA;EACE,0BAAA;AAFF;;AAKA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,uBAAA;EACA,sBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,uDAAA;AAFF;;AAKA;EACE,gBAAA;EACA,eAAA;EACA,qCAAA;AAFF;;AAKA;EACE,iBAAA;AAFF;;AAKA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;AAFF;;AAKA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;AAFF;;AAMA;EAuCE,gDAAA;EAUA,oCAAA;AAlDF;AAGE;EACE,mBAAA;EACA,gBAAA;AADJ;AAKE;;EAEE,WAAA;AAHJ;AAME;EACE,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,uEAAA;EACA,YAAA;AAJJ;AAOE;EACE,2BAAA;EACA,0CAAA;AALJ;AAOI;EACE,uBAAA;AALN;AASE;EACE;IACE,aAAA;IACA,YAAA;IACA,aAAA;IACA,yDAAA;EAPJ;AACF;AAWE;EACE;IACE,aAAA;IACA,YAAA;IACA,aAAA;IACA,yDAAA;EATJ;AACF;AAaE;EACE;IACE,aAAA;IACA,YAAA;IACA,aAAA;IACA,yDAAA;EAXJ;AACF;AAcE;EACE;IACE,aAAA;IACA,YAAA;IACA,aAAA;IACA,yDAAA;EAZJ;AACF;AAeE;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EAEA,aAAA;EACA,mBAAA;EACA,QAAA;AAdJ;AAgBI;EACE,iBAAA;EACA,mBAAA;EAEA,WAAA;EACA,gBAAA;EACA,qBAAA;EAEA,8DAAA;EAKA,0BAAA;EAEA,gGACE;EAGF,2CAAA;AAxBN;AA6BE;EACE,aAAA;EACA,SAAA;EACA,kBAAA;AA3BJ;AA6BI;EACE,6BAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;AA3BN;AA+BE;EACE,yBAAA;EACA,oCAAA;AA7BJ;AAgCE;EACE,eAAA;EACA,4BAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;AA9BJ;AAiCE;EACE,eAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AA/BJ;AAkCE;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AAhCJ;AAmCE;EACE,eAAA;AAjCJ;;AA0CA,iDAAA;AACA;EAGI;IACE,eAAA;EAzCJ;EA4CE;IACE,eAAA;EA1CJ;EA8CA;IACE,2BAAA;IACA,sBAAA;EA5CF;EA+CA;IACE,uBAAA;EA7CF;AACF;AAgDA;EAEE;IAKE,wBAAA;EAnDF;EAsDA;IACE,4BAAA;EApDF;EAuDA;IACE,4BAAA;EArDF;AACF;AAwDA;EACE,6BAAA;AAtDF;;AA4DA;EACE,iEAAA;EACA,sBAAA;AAzDF;;AA4DA;EACE,iEAAA;EACA,yBAAA;AAzDF;;AA6DA;EACE,WAAA;AA1DF;;AA6DA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AA1DF;;AA6DA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AA1DF;AA4DE;EACE,iBAAA;AA1DJ;;AA+DA;EAGE,sBAAA;AA9DF;;AAiEA;EACE,0BAAA;AA9DF;;AAiEA;EACE,8BAAA;AA9DF;;AAmEA;EAIE,iBAAA;EACA,6BAAA;AAnEF;AAqEE;EACE,uCAAA;AAnEJ;;AA2EA;EACE,6CAAA;EACA,6CAAA;EACA,sDAAA;EACA,iBAAA;EACA,6BAAA;EACA,0BAAA;EACA,YAAA;EACA,UAAA;AAxEF;AA0EE;EACE,6CAAA;AAxEJ;;AA4EA;EACE,mDAAA;AAzEF;;AA4EA;EACE,aAAA;AAzEF;;AA4EA;EACE,6CAAA;EACA,sDAAA;EACA,6CAAA;EACA,8BAAA;EACA,0BAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,mDAAA;AAzEF;;AA4EA;EACE,uBAAA;AAzEF;;AA4EA;EACE,6CAAA;EACA,sDAAA;EACA,6CAAA;EACA,8BAAA;EACA,0BAAA;EACA,YAAA;EACA,gDAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,mDAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,WAAA;AAzEF;;AA4EA;EACE,yBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,kBAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,qCAAA;AAzEF;;AA6EA;EACE,8BAAA;EACA,WAAA;EACA,0BAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AA1EF;;AA8EA;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AA3EF;;AAiFA;EACE,qHAAA;EAIA,gCAAA;EACA,yBAAA;AAjFF;;AAoFA;EACE,gGAAA;AAjFF;;AAuFA;EACE,yBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AApFF;;AAuFA;EACE,2BAAA;AApFF;;AAuFA;EACE,oCAAA;AApFF;;AAuFA;EACE,yBAAA;AApFF;;AAuFA;EACE,yBAAA;AApFF;;AAuFA;EACE,oCAAA;AApFF;;AAwFA;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EAEA,qBAAA;AAtFF;;AAyFA;EACE,WAAA;EACA,yBAAA;AAtFF;;AAyFA;EACE,cAAA;EACA,gDAAA;AAtFF;;AAyFA;EACE,cAAA;EACA,gDAAA;AAtFF;;AAyFA;EACE,cAAA;EACA,yBAAA;AAtFF;;AAyFA;EACE,cAAA;EACA,kDAAA;AAtFF;;AAyFA;EACE,qCAAA;EACA,+CAAA;AAtFF;;AAyFA;EACE,cAAA;EACA,iDAAA;AAtFF;;AAyFA;EACE,cAAA;EACA,+CAAA;AAtFF;;AAyFA;EACE,cAAA;EACA,mDAAA;AAtFF;;AAyFA;EACE,cAAA;EACA,mDAAA;AAtFF;;AAyFA;EACE,cAAA;EACA,kDAAA;AAtFF;;AAyFA;EACE,cAAA;AAtFF;;AAyFA;EACE,cAAA;AAtFF;;AAyFA;EACE,cAAA;EACA,yBAAA;AAtFF;;AAyFA;EACE,cAAA;EACA,yBAAA;AAtFF;;AAyFA;EACE,WAAA;EACA,yBAAA;AAtFF;;AA0FA;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AAvFF;;AA2FA;EACE,cAAA;EACA,iDAAA;AAxFF;;AA2FA;EACE,cAAA;EACA,iDAAA;AAxFF;;AA2FA;EACE,cAAA;EACA,kDAAA;AAxFF;;AA2FA;EACE,qCAAA;EACA,gDAAA;AAxFF;;AA2FA;EACE,cAAA;EACA,gDAAA;AAxFF;;AA2FA;EACE,WAAA;EACA,yBAAA;AAxFF;;AA2FA;EACE,cAAA;EACA,yBAAA;AAxFF;;AA2FA;EACE,WAAA;EACA,yBAAA;AAxFF;;AA2FA;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,SAAA;AAxFF;;AA2FA;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AAxFF;;AA2FA;EACE,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAxFF;;AA4FA;EACE,2DAAA;EACA,mDAAA;AAzFF;;AA4FA;EACE,iCAAA;EACA,sBAAA;EACA,8DAAA;EACA,2BAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,gCAAA;AAzFF;AA2FE;EACE,aAAA;EACA,gBAAA;AAzFJ;AA4FE;EACE,eAAA;EACA,gBAAA;AA1FJ;AA6FE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AA3FJ;AA8FE;EACE,iCAAA;AA5FJ;;AAgGA;EACE,2BAAA;AA7FF;;AAiGA;EACE,eAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;AA9FF;;AAkGA;EACE,2BAAA;AA/FF;;AAkGA;EACE,oCAAA;AA/FF;;AAkGA;EACE,gBAAA;EACA,iBAAA;AA/FF;;AAmGE;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAhGJ;AAmGE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAjGJ;;AAsGE;EACE,WAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;AAnGJ;AAsGE;EACE,eAAA;AApGJ;AAuGE;EACE,6BAAA;EACA,sCAAA;EACA,oBAAA;EACA,qCAAA;AArGJ;;AAyGA;EACE,eAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAtGF;;AAyGA;EACE,2BAAA;AAtGF;;AAyGA;EACE,eAAA;EACA,eAAA;AAtGF;;AAyGA;EACE,cAAA;AAtGF;;AAyGA;EACE,yDAAA;EACA,eAAA;EACA,mCAAA;EACA,qCAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AAtGF;;AA2GE;EACE,YAAA;EACA,WAAA;AAxGJ;AA2GE;EAME,YAAA;AA9GJ;AAyGI;EACE,aAAA;EACA,gCAAA;AAvGN;AA4GI;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AA1GN;AA6GI;EACE,kBAAA;EACA,kBAAA;AA3GN;AA8GI;EAEE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;AA7GN;;AAkHA,6DAAA;AACA;EACE,WAAA;EACA,2DAAA;EACA,yBAAA;EACA,wCAAA;AA/GF;;AAmHA;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,wBAAA;EACA,eAAA;AAhHF;AAkHE;;EAEE,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;AAhHJ;AAmHE;;EAEE,UAAA;EACA,iCAAA;AAjHJ;AAoHE;;EAEE,UAAA;EACA,8CAAA;AAlHJ;AAqHE;EACE,iBAAA;AAnHJ;;AAuHA;EACE,wBAAA;EACA,8BAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;AApHF;;AAuHA;EACE,SAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AApHF;;AAuHA;EACE,iBAAA;AApHF;;AAwHA;EACE,kBAAA;EACA,0BAAA;AArHF;;AAwHA;EACE,cAAA;EACA,kBAAA;EACA,WAAA;AArHF;;AAwHA;EACE,6BAAA;AArHF;;AAwHA;;EAEE,yBAAA;EACA,gCAAA;EACA,gBAAA;EACA,kDAAA;EACA,gBAAA;EACA,0CAAA;AArHF;;AAwHA,mCAAA;AACA;EACE,iBAAA;EACA,cAAA;EACA,yCAAA;AArHF;;AAwHA,wDAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AArHF;;AAwHA,uBAAA;AACA;EACE,yBAAA;EACA,2BAAA;EACA,kBAAA;EAEA,4BAAA;AArHF;;AAwHA;EACE,qBAAA;EACA,4BAAA;EACA,kBAAA;EAEA,4BAAA;AArHF;;AAwHA,wBAAA;AACA;EACE,WAAA;EACA,yBAAA;EACA,gBAAA;AArHF;;AAwHA;;EAEE,yBAAA;EACA,gBAAA;EACA,gBAAA;AArHF;;AAwHA;EACE,iBAAA;EACA,cAAA;AArHF;;AAwHA;EACE,YAAA;EACA,mCAAA;EACA,kBAAA;EACA,uCAAA;AArHF;;AAwHA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AArHF;;AAwHA;EACE,WAAA;EACA,YAAA;AArHF;;AAwHA;EACE,6BAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AArHF;;AAwHA;EACE,gBAAA;EACA,6BAAA;EACA,iBAAA;EACA,cAAA;AArHF;;AAyMA;;;;;;EAME,8DAAA;EACA,6BAAA;EACA,0BAAA;EACA,YAAA;EACA,2DAAA;AAtMF;;AAyMA;EACE,YAAA;EACA,WAAA;EACA,oCAAA;AAtMF;;AAyMA;EACE,8BAAA;EACA,gBAAA;EACA,yCAAA;AAtMF;;AA0MA;;;;;;;;;;;EAWE,uNAAA;EAGA,4BAAA;AAzMF;;AA6ME;EACE,gEAAA;AA1MJ;;AA+ME;EAEE,6BAAA;EACA,0BAAA;EACA,+CAAA;AA7MJ;AAiNE;EACE,gBAAA;EACA,kBAAA;AA/MJ;AAkNE;;EAEE,yBAAA;EACA,qBAAA;EACA,WAAA;AAhNJ;;AAoNA;EACE,aAAA;AAjNF;;AAoNA;EACE,WAAA;AAjNF;;AAoNA;EACE,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AAjNF;AAmNE;EACE,uBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AAjNJ;AAoNE;EACE,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;AAlNJ;;AAsNA;EACE,SAAA;AAnNF;;AAsNA;EACE,gBAAA;EACA,eAAA;AAnNF;;AAsNA;EACE,gCAAA;AAnNF;;AAyNA;EACE,eAAA;AAtNF;;AAyNA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAtNF;;AAyNA;EACE,oBAAA;EACA,0DAAA;AAtNF;;AAyNA,UAAA;AACA;EACE,UAAA;AAtNF;;AAyNA,UAAA;AACA;EACE,mBAAA;AAtNF;;AAyNA,WAAA;AACA;EACE,mBAAA;AAtNF;;AAyNA,oBAAA;AACA;EACE,gBAAA;AAtNF;;AAyNA,8BAAA;AACA,YAAA;AACA;EACE,qBAAA;EACA,gCAAA;AAtNF;;AAyNA,6BAAA;AACA;EACE,WAAA;AAtNF;;AAyNA;EACE,mBAAA;AAtNF;;AAyNA;EACE,yBAAA;EACA,mBAAA;EACA,yBAAA;AAtNF;;AAyNA;EACE,sBAAA;AAtNF;;AAyNA;EACE,sBAAA;AAtNF;;AA0NA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAvNF;;AA0NA;EACE,eAAA;AAvNF;;AA0NA;EACE,iBAAA;EACA,iBAAA;AAvNF;AAyNE;EACE,eAAA;EACA,UAAA;EACA,eAAA;AAvNJ;AA0NE;EACE,eAAA;AAxNJ;;AA6NE;EACE,eAAA;EACA,uBAAA;EACA,eAAA;AA1NJ;;AA+NE;EACE,uBAAA;EACA,2BAAA;AA5NJ;;AAgOA;EACE,WAAA;EACA,eAAA;AA7NF;;AAoOA;EACE,kDAAA;AAjOF;;AAoOA;EACE,2BAAA;EACA,yBAAA;AAjOF;;AAoOA;EACE,iEAAA;EACA,eAAA;AAjOF;;AAqOE;EACE,YAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAlOJ;AAqOE;EACE,uBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAnOJ;;AAuOA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AApOF;AAsOE;EACE,cAAA;EACA,mDAAA;EACA,kBAAA;EACA,gBAAA;AApOJ;;AAwOA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AArOF;AAuOE;EACE,cAAA;EACA,mDAAA;EACA,kBAAA;EACA,gBAAA;AArOJ;;AAyOA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAtOF;;AAyOA;EACE,0DAAA;AAtOF;;AAyOA;EACE,oCAAA;AAtOF;;AAyOA;EACE,cAAA;AAtOF;;AAyOA;EACE,cAAA;AAtOF;;AA2OE;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;AAxOJ;;AA6OA;EACE,yBAAA;AA1OF;;AA8OA;EACE,yBAAA;EACA,2EAAA;AA3OF;AA6OE;EACE,+BAAA;AA3OJ;AA8OE;EACE,gCAAA;AA5OJ;AA+OE;EACE;IACE,UAAA;IACA,qBAAA;EA7OJ;EAgPE;IACE,UAAA;IACA,mBAAA;EA9OJ;AACF;AAiPE;EACE;IACE,UAAA;IACA,mBAAA;EA/OJ;EAkPE;IACE,UAAA;IACA,qBAAA;EAhPJ;AACF;AAmPE;EACE,UAAA;AAjPJ;AAoPE;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAlPJ;AAqPE;EACE,yBAAA;EACA,kBAAA;EACA,oCAAA;EACA,4BAAA;AAnPJ;AAqPI;EACE,kBAAA;AAnPN;AAsPI;EACE,gBAAA;EACA,WAAA;AApPN;AAuPI;EACE,eAAA;EACA,cAAA;EACA,eAAA;AArPN;AAwPI;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;AAtPN;AA0PE;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAxPJ;AA0PI;EACE,qBAAA;EACA,cAAA;EACA,kBAAA;AAxPN;AA2PI;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;AAzPN;AA6PE;EACE,eAAA;AA3PJ;AA8PE;EACE,eAAA;EACA,gBAAA;AA5PJ;AA+PE;EACE,eAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;AA7PJ;AAgQE;EACE,qBAAA;AA9PJ;AAiQE;EACE,eAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA/PJ;AAkQE;EACE,qBAAA;AAhQJ;AAmQE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAjQJ;AAoQE;EACE,qBAAA;AAlQJ;AAqQE;EACE,UAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,wBAAA;AAnQJ;AAqQI;EACE,iCAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,wBAAA;AAnQN;AAsQI;EACE,kCAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,wBAAA;AApQN;;AA0QE;EACE,6BAAA;EACA,YAAA;AAvQJ;;AA+QE;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AA5QJ;AA+QE;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA7QJ;AAgRE;EACE,yBAAA;EACA,kBAAA;EACA,oCAAA;EACA,uCAAA;AA9QJ;AAgRI;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;AA9QN;AAiRI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AA/QN;AAkRI;EACE,kBAAA;AAhRN;AAmRI;EACE,gBAAA;EACA,WAAA;AAjRN;AAoRI;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAlRN;AAqRI;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;AAnRN;AAuRE;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AArRJ;AAuRI;EACE,qBAAA;EACA,cAAA;EACA,kBAAA;AArRN;AAwRI;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;AAtRN;AA0RE;EACE,UAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,wBAAA;AAxRJ;AA0RI;EACE,iCAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,wBAAA;AAxRN;AA2RI;EACE,kCAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,wBAAA;AAzRN;;AAoSE;EACE,eAAA;EACA,yBAAA;AAjSJ;AAoSE;EACE,UAAA;AAlSJ;AAqSE;EACE,YAAA;AAnSJ;AAsSE;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AApSJ;AAuSE;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AArSJ;AAySI;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AAvSN;AA0SI;EACE,eAAA;EACA,gBAAA;AAxSN;AA4SE;EACE,yBAAA;EACA,kBAAA;EACA,oCAAA;EACA,4BAAA;AA1SJ;AA4SI;EACE,kBAAA;AA1SN;AA6SI;EACE,gBAAA;EACA,WAAA;AA3SN;AA8SI;EACE,cAAA;EACA,eAAA;AA5SN;AAgTE;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AA9SJ;AAgTI;EACE,qBAAA;EACA,cAAA;EACA,YAAA;AA9SN;AAiTI;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;AA/SN;AAmTE;EACE,qBAAA;AAjTJ;AAoTE;EACE,UAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,wBAAA;AAlTJ;AAoTI;EACE,iCAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,wBAAA;AAlTN;AAqTI;EACE,kCAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,wBAAA;AAnTN;;AA2TA;EACE,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,wCAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gDAAA;EACA,gBAAA;AAxTF;;AA2TA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,wCAAA;AAxTF;;AA2TA;EACE,4BAAA;AAxTF;;AA2TA,gDAAA;AACA;EACE;IACE,wBAAA;EAxTF;EA2TA;IACE,2BAAA;EAzTF;AACF;AA6TA;EACE,YAAA;EACA,uBAAA;EAEA,gDAAA;EACA,mBAAA;EACA,gBAAA;AA5TF;AA8TE;EACE,aAAA;EACA,+CAAA;EACA,kBAAA;AA5TJ;AA+TE;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;AA7TJ;AAgUE;EACE,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,gDAAA;EACA,2BAAA;AA9TJ;AAiUE;EACE,yCAAA;EACA,cAAA;AA/TJ;AAkUE;EACE,0CAAA;EACA,cAAA;AAhUJ;AAmUE;EACE,0CAAA;EACA,cAAA;AAjUJ;AAoUE;EACE,cAAA;EACA,iDAAA;AAlUJ;;AAyUA;EACE,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAtUF;;AAyUA;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAtUF;;AAyUA;EACE,uCAAA;AAtUF;;AAyUA;EACE,yBAAA;AAtUF;;AAyUA;EACE,aAAA;EACA,gBAAA;EACA,iCAAA;AAtUF;;AAyUA;EACE,iBAAA;EACA,wBAAA;EACA,kBAAA;AAtUF;;AAkVA;EACE,gBAAA;EACA,mBAAA;EACA,WAAA;AA/UF;;AAkVA;EACE,kBAAA;AA/UF;AAiVE;EACE,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,2CAAA;EACA,0BAAA;AA/UJ;AAkVE;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AAhVJ;AAmVE;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,iCAAA;EACA,eAAA;AAjVJ;AAoVE;EACE,mBAAA;AAlVJ;AAqVE;EACE,WAAA;EACA,gBAAA;AAnVJ;AAsVE;EACE,WAAA;EACA,gBAAA;AApVJ;;AA2VA;EACE,0CAAA;EACA,cAAA;AAxVF;;AA2VA;EACE,mBAAA;EACA,cAAA;AAxVF;;AA6VA;EACE,wBAAA;EACA,6BAAA;AA1VF;AA4VE;EACE,2DAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA1VJ;AA6VE;EACE,wBAAA;AA3VJ;AA8VE;EACE,aAAA;EACA,kBAAA;AA5VJ;AA+VE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AA7VJ;AAgWE;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;AA9VJ;AAiWE;EACE,4BAAA;EACA,mBAAA;AA/VJ;AAkWE;EACE,kBAAA;AAhWJ;AAmWE;EACE,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AAjWJ;AAmWI;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAjWN;AAoWI;EACE,eAAA;EACA,cAAA;AAlWN;AAqWI;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAnWN;AAuWE;EACE,WAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;AArWJ;AAwWE;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AAtWJ;AAyWE;;EAEE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAvWJ;AA0WE;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,mBAAA;AAxWJ;AA2WE;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAzWJ;AA4WE;;EAEE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA1WJ;AA6WE;EAEE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AA5WJ;AA+WE;EAEE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AA9WJ;AAiXE;;EAEE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA/WJ;AAkXE;EACE,UAAA;AAhXJ;AAmXE;EACE,YAAA;EACA,cAAA;EACA,eAAA;AAjXJ;AAoXE;EACE,YAAA;EACA,iGAAA;EACA,6CAAA;AAlXJ;AAqXE;EACE,YAAA;EACA,8FAAA;EACA,yBAAA;EACA,qCAAA;AAnXJ;AAsXE;EACE;IACE,wBAAA;EApXJ;EAuXE;IACE,sCAAA;IACA,cAAA;EArXJ;AACF;;AAiYA;EACE,YAAA;AA9XF;;AAiYA;EACE,aAAA;EACA,aAAA;EACA,kBAAA;AA9XF;;AAiYA;EACE,YAAA;EACA,6BAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;AA9XF;AAgYE;EACE,eAAA;EAEA,yBAAA;EACA,yBAAA;EACA,kBAAA;AA/XJ;AAiYI;EACE,yBAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AA/XN;AAkYI;EACE,yBAAA;EACA,iBAAA;AAhYN;AAoYE;EACE,mDAAA;AAlYJ;AAqYE;EACE,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,+CAAA;AAnYJ;AAqYI;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;AAnYN;AAsYI;EACE,yBAAA;EACA,iBAAA;AApYN;;AAyYA;EACE,eAAA;AAtYF;AAwYE;EACE,eAAA;EACA,gBAAA;AAtYJ;AAyYE;EACE,oCAAA;AAvYJ;;AA2YA;EACE,cAAA;AAxYF;;AA2YA;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAxYF;;AA2YA;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAxYF;;AA2YA;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAxYF;;AA2YA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;AAxYF;;AA2YA;EACE,WAAA;AAxYF;;AA2YA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAxYF;;AA2YA;EACE,gBAAA;EACA,eAAA;AAxYF;;AA2YA;EACE,6BAAA;EACA,6BAAA;AAxYF;;AA2YA;EACE,aAAA;AAxYF;;AA4YE;EACE,gBAAA;AAzYJ;AA4YE;EACE,2DAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;AA1YJ;AA6YE;EACE,sBAAA;EACA,cAAA;EACA,aAAA;AA3YJ;AA6YI;EACE,eAAA;AA3YN;;AAgZA;EACE,WAAA;AA7YF;;AAgZA;EACE,aAAA;AA7YF;;AAmZI;EACE,wBAAA;EACA,eAAA;EACA,gBAAA;AAhZN;AAmZI;EACE,UAAA;EACA,iBAAA;AAjZN;AAsZI;EACE,qBAAA;AApZN;;AAyZA;EACE,aAAA;AAtZF;AAwZE;EACE,UAAA;EACA,iBAAA;AAtZJ;;AA0ZA;EACE,2BAAA;AAvZF;;AA0ZA;EACE,iBAAA;AAvZF;;AA0ZA;EACE,mBAAA;AAvZF;;AA0ZA;EACE,yBAAA;EACA,kBAAA;EACA,4BAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mCAAA;AAvZF;;AA0ZA;EACE,mBAAA;EACA,aAAA;EACA,2BAAA;AAvZF;AAyZE;EACE,iBAAA;AAvZJ;;AA2ZA;EACE,eAAA;AAxZF;;AA6ZE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AA1ZJ;AA6ZE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,6CAAA;AA3ZJ;AA8ZE;EACE,yBAAA;EACA,kBAAA;AA5ZJ;AA+ZE;EACE,yBAAA;EACA,sBAAA;AA7ZJ;AAgaE;EACE,yBAAA;EACA,qBAAA;AA9ZJ;AAiaE;EACE,yBAAA;EACA,sBAAA;AA/ZJ;AAkaE;EACE;IACE,mBAAA;EAhaJ;EAmaE;IACE,qBAAA;EAjaJ;EAoaE;IACE,mBAAA;EAlaJ;AACF;;AAuaA;EACE,uBAAA;AApaF;AAsaE;EACE,sBAAA;EACA,6BAAA;AApaJ;;AAwaA;EACE,YAAA;EACA,iBAAA;AAraF;AAuaE;EACE,eAAA;AAraJ;;AA0aE;EACE,eAAA;AAvaJ;;AA2aA;EACE,eAAA;EACA,cAAA;AAxaF;;AA2aA;EACE,YAAA;EACA,iBAAA;AAxaF;;AA4aA;EACE,aAAA;EACA,mBAAA;AAzaF;AA2aE;EACE,YAAA;EACA,WAAA;AAzaJ;AA4aE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AA1aJ;;AA+aE;EACE,YAAA;EACA,YAAA;AA5aJ;AA8aI;EACE,WAAA;EACA,YAAA;AA5aN;;AAibA;EACE,kBAAA;AA9aF;;AAibA;EACE,YAAA;EACA,gBAAA;AA9aF;AAgbE;EACE,YAAA;AA9aJ;;AAkbA;EACE,+BAAA;AA/aF;;AAkbA;EACE,kBAAA;EACA,2CAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,iDAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,wCAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;AA/aF;AAibE;EACE,eAAA;AA/aJ;;AAmbA;EACE,yBAAA;EACA,oBAAA;AAhbF;;AAmbA;EACE,cAAA;EACA,gBAAA;EACA,uCAAA;EACA,gBAAA;EACA,yCAAA;EACA,cAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,4CAAA;AAhbF;;AAmbA;EACE,WAAA;AAhbF;;AAmbA;EACE,WAAA;AAhbF;;AAmbA;EACE,aAAA;AAhbF;;AAmbA;EACE,aAAA;AAhbF;;AAmbA;EACE,aAAA;AAhbF;;AAmbA;EAEE,6BAAA;AAjbF;;AAobA;EAEE,6BAAA;AAlbF;;AAsbA;;EAEE,oCAAA;AAnbF;;AAsbA;EACE,oCAAA;AAnbF;;AAmcA,sBAAA;AACA;EACE;IACE,gBAAA;IACA,gBAAA;IACA,gBAAA;EAhcF;AACF;AAmcA,4DAAA;AACA;EACE;IACE,gBAAA;IACA,0BAAA;IACA,gBAAA;IACA,gBAAA;IACA,uBAAA;EAjcF;AACF;AAocA;EACE;IACE,YAAA;IACA,gBAAA;IACA,gBAAA;EAlcF;AACF;AAqcA;;EAEE,oCAAA;AAncF;;AAycA,0DAAA;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AAvcF;;AA0cA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,0CAAA;AAvcF;;AA0cA;EACE,eAAA;AAvcF;;AA0cA;EACE,sBAAA;AAvcF;;AA0cA;EACE,sBAAA;AAvcF;;AA0cA;EACE,qBAAA;AAvcF;;AA0cA;EACE;IACE,qBAAA;IACA,yBAAA;IACA,4CAAA;EAvcF;EA0cA;IACE,qBAAA;IACA,yBAAA;IACA,6CAAA;EAxcF;EA2cA;IACE,qBAAA;IACA,yBAAA;IACA,4CAAA;EAzcF;AACF;AA4cA,gCAAA;AACA;EACE,qCAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,0CAAA;EACA,2BAAA;EACA,0CAAA;AA1cF;;AA6cA;EACE,uCAAA;EACA,2CAAA;AA1cF;;AA6cA,yBAAA;AACA;EACE,qDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,iBAAA;EACA,WAAA;EACA,yBAAA;AA1cF;;AA6cA;EACE,qDAAA;AA1cF;;AA6cA,sBAAA;AACA;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;AA1cF;;AA6cA;EACE,cAAA;EACA,iBAAA;AA1cF;;AA6cA,4BAAA;AACA;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;AA1cF;;AA6cA;EACE,qBAAA;EACA,cAAA;AA1cF;;AA6cA;EACE,qBAAA;EACA,cAAA;AA1cF;;AA6cA;EACE,qBAAA;EACA,cAAA;AA1cF;;AA+cA,+BAAA;AACA;EACE,iBAAA;EACA,gBAAA;AA5cF;;AA+cA;EACE,cAAA;EACA,mBAAA;AA5cF;;AAidA;EACE,eAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;AA9cF;;AAidA;EACE,cAAA;AA9cF;;AAidA;EACE,yBAAA;EACA,kBAAA;EACA,2BAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mCAAA;AA9cF;;AAidA;EACE,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;AA9cF;;AAidA;EACE,cAAA;AA9cF;;AAmdE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AAhdJ;AAmdE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,6CAAA;AAjdJ;AAodE;EACE,yBAAA;EACA,kBAAA;AAldJ;AAqdE;EACE,yBAAA;EACA,sBAAA;AAndJ;AAsdE;EACE,yBAAA;EACA,qBAAA;AApdJ;AAudE;EACE,yBAAA;EACA,sBAAA;AArdJ;AAwdE;EACE;IACE,mBAAA;EAtdJ;EAydE;IACE,qBAAA;EAvdJ;EA0dE;IACE,mBAAA;EAxdJ;AACF;;AA6dA,0CAAA;AACA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AA1dF;;AA6dA,uBAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,6DAAA;EACA,yBAAA;EACA,4CAAA;EACA,qDAAA;AA1dF;;AA6dA;EACE,2BAAA;EACA,4CAAA;AA1dF;;AA6dA,+BAAA;AACA;EACE,WAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AA1dF;;AA6dA;EACE,mBAAA;AA1dF;;AA6dA;EACE,mBAAA;AA1dF;;AA6dA,aAAA;AACA;EACE,mBAAA;AA1dF;;AA6dA,aAAA;AAEA,gBAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AA3dF;;AA8dA,SAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AA3dF;;AA8dA;EACE,eAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;AA3dF;;AA8dA;EACE,aAAA;EACA,qBAAA;EACA,QAAA;AA3dF;;AA8dA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,kCAAA;AA3dF;;AA8dA;EACE,eAAA;EACA,cAAA;AA3dF;;AA8dA,2CAAA;AACA;EACE;IACE,0BAAA;EA3dF;AACF;AA+dA,kCAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,YAAA;EACA,eAAA;EACA,4BAAA;EACA,6CAAA;EACA,kBAAA;EACA,kBAAA;AA9dF;;AAieA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,oDAAA;EACA,kBAAA;AA9dF;;AAieA;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,0CAAA;AA9dF;;AAieA;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;AA9dF;;AAieA;EACE,kBAAA;EACA,qBAAA;EACA,kBAAA;AA9dF;;AAieA,6CAAA;AACA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,oDAAA;EACA,6BAAA;EACA,oCAAA;EACA,yCAAA;AA9dF;;AAieA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,oDAAA;EACA,4CAAA;AA9dF;;AAieA;EACE,kCAAA;AA9dF;;AAieA;EACE,oCAAA;EACA,kBAAA;AA9dF;;AA0gBA;EACE,yBAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,oDAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;AAvgBF;;AA0gBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AAvgBF;;AA0gBA;;EAEE,aAAA;EACA,mBAAA;EACA,QAAA;AAvgBF;;AA0gBA;EACE,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AAvgBF;;AA0gBA;EACE,0BAAA;AAvgBF;;AA0gBA;EACE,YAAA;EACA,sBAAA;EACA,+BAAA;EACA,+CAAA;AAvgBF;;AA0gBA;EACE;IACE,sBAAA;IACA,kBAAA;IACA,QAAA;EAvgBF;AACF;AA0gBA;EACE,yBAAA;EACA,oBAAA;EACA,iCAAA;AAxgBF;AA0gBE;EACE,YAAA;AAxgBJ;AA2gBE;EACE,0BAAA;EACA,kBAAA;EACA,iBAAA;AAzgBJ;AA4gBE;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AA1gBJ;AA6gBE;EACE,eAAA;AA3gBJ;;AA+gBA;EACE,aAAA;EACA,qCAAA;EACA,gBAAA;EACA,qCAAA;EACA,aAAA;AA5gBF;;AAohBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAjhBJ;AAmhBI;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EAEA,gHACE;EAIF,iCAAA;AAthBN;AAyhBI;EACE,cAAA;EACA,sBAAA;AAvhBN;;AA4hBA;EACE;IACE,8EACE;EA1hBJ;EA8hBA;IACE,2GACE;EA7hBJ;EAkiBA;IACE,8EACE;EAjiBJ;AACF;AAsiBA;EACE,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,8DAAA;EAIA,0BAAA;EACA,sCAAA;EACA,6CAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AAviBF;;AA0iBA;EACE;IACE,2BAAA;IACA,mBAAA;EAviBF;EA0iBA;IACE,6BAAA;IACA,sBAAA;EAxiBF;EA2iBA;IACE,2BAAA;IACA,mBAAA;EAziBF;AACF;AA4iBA;EACE,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,qDAAA;EACA,gDAAA;EACA,WAAA;EACA,kBAAA;AA1iBF;;AAmlBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAhlBF;;AAmlBA;EACE,aAAA;EACA,QAAA;AAhlBF;;AAmlBA;EACE,WAAA;EACA,YAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,mBAAA;EACA,cAAA;EAEA,kBAAA;EACA,sBAAA;EAEA,eAAA;EACA,gBAAA;EACA,sBAAA;EAEA,yCAAA;AArlBF;;AAwlBA;EACE,eAAA;AArlBF;;AAwlBA;EACE,YAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;AArlBF;AAulBE;EACE,eAAA;EACA,WAAA;EACA,qBAAA;AArlBJ;AAwlBE;EACE,WAAA;AAtlBJ;;AA2lBE;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAxlBJ;AA0lBI;EACE,WAAA;AAxlBN;AA2lBI;EACE,mBAAA;EACA,mBAAA;AAzlBN;AA4lBI;EACE,mBAAA;EACA,mBAAA;AA1lBN;AA6lBI;EACE,gBAAA;AA3lBN;AA+lBE;EACE,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,8BAAA;EACA,mBAAA;EACA,yCAAA;AA7lBJ;AAgmBE;EACE,SAAA;EACA,YAAA;AA9lBJ;AAimBE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA/lBJ;AAkmBE;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAhmBJ;AAmmBE;EACE,kBAAA;EACA,iBAAA;AAjmBJ;AAomBE;EACE,eAAA;EACA,cAAA;EACA,yBAAA;AAlmBJ;AAqmBE;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAnmBJ;AAsmBE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,eAAA;EACA,gBAAA;EACA,cAAA;EAEA,0BAAA;EACA,kBAAA;EACA,mBAAA;AAtmBJ;;AA0mBA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,WAAA;AAvmBF;AAymBE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAvmBJ;AAymBI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACL,qBAAA;EACC,gCAAA;AAvmBF;AA0mBI;EACE,eAAA;EACA,eAAA;EACA,gBAAA;AAxmBN;AA4mBE;EACE,mBAAA;AA1mBJ;AA4mBI;EACE,cAAA;AA1mBN;AA6mBI;EACE,cAAA;AA3mBN;AA+mBE;EACE,2CAAA;AA7mBJ;AA+mBI;EACE,cAAA;AA7mBN;AAgnBI;EACE,cAAA;AA9mBN;AAknBE;EACE,yCAAA;AAhnBJ;AAknBI;EACE,cAAA;AAhnBN;AAmnBI;EACE,cAAA;AAjnBN;AAqnBE;EACE,0CAAA;AAnnBJ;AAqnBI;EACE,cAAA;AAnnBN;AAsnBI;EACE,cAAA;AApnBN;AAwnBE;EACE,0CAAA;AAtnBJ;AAwnBI;EACE,cAAA;AAtnBN;AAynBI;EACE,cAAA;AAvnBN;AA2nBE;EACE,yCAAA;AAznBJ;AA2nBI;EACE,qCAAA;AAznBN;AA4nBI;EACE,qCAAA;AA1nBN;AA8nBE;EACE,mBAAA;AA5nBJ;AA8nBI;EACE,cAAA;AA5nBN;AA+nBI;EACE,cAAA;AA7nBN;AAioBA;EACE;IACE,UAAA;IACA,2BAAA;EA/nBF;EAioBA;IACE,UAAA;IACA,wBAAA;EA/nBF;AACF;;AAmoBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,0BAAA;EACA,2CAAA;EACA,yBAAA;AAhoBF;AAkoBE;EACE,2BAAA;EACA,wBAAA;AAhoBJ;;AAooBA,SAAA;AACA;EAEE,mCAAA;EACA,cAAA;AAloBF;;AAqoBA,QAAA;AACA;EAEE,oCAAA;EACA,cAAA;AAnoBF;;AAsoBA,SAAA;AACA;EAEE,mCAAA;EACA,cAAA;AApoBF;;AAuoBA,SAAA;AACA;EAEE,oCAAA;EACA,cAAA;AAroBF;;AAwoBA,YAAA;AACA;EAEE,oCAAA;EACA,cAAA;AAtoBF;;AAyoBA,UAAA;AACA;EAEE,mCAAA;EACA,cAAA;AAvoBF;;AA0oBA,SAAA;AACA;EAEE,oCAAA;EACA,cAAA;AAxoBF;;AA2oBA,WAAA;AACA;EAEE,oCAAA;EACA,cAAA;AAzoBF;;AA4oBA,UAAA;AACA;EAEE,oCAAA;EACA,cAAA;AA1oBF;;AA6oBA,WAAA;AACA;EAEE,oCAAA;EACA,cAAA;AA3oBF;;AA8oBA,gBAAA;AACA;EAEE,mCAAA;EACA,cAAA;AA5oBF;;AA+oBA,UAAA;AACA;EAEE,qCAAA;EACA,cAAA;AA7oBF;;AAgpBA,QAAA;AACA;EAEE,mCAAA;EACA,cAAA;AA9oBF;;AAipBA,SAAA;AACA;EAEE,mCAAA;EACA,cAAA;AA/oBF;;AAkpBA,SAAA;AACA;EAEE,oCAAA;EACA,cAAA;AAhpBF;;AAmpBA,YAAA;AACA;EAEE,oCAAA;EACA,cAAA;AAjpBF;;AAopBA,WAAA;AACA;EAEE,oCAAA;EACA,cAAA;AAlpBF;;AAqpBA,WAAA;AACA;EAEE,oCAAA;EACA,cAAA;AAnpBF;;AAspBA,WAAA;AACA;EAEE,oCAAA;EACA,cAAA;AAppBF;;AAupBA,UAAA;AACA;EAEE,qCAAA;EACA,cAAA;AArpBF;;AAwpBA,SAAA;AACA;EAEE,qCAAA;EACA,cAAA;AAtpBF;;AAypBA,SAAA;AACA;EAEE,kCAAA;EACA,cAAA;AAvpBF;;AA0pBA,UAAA;AACA;EAEE,mCAAA;EACA,cAAA;AAxpBF;;AA2pBA,cAAA;AACA;EAEE,mCAAA;EACA,cAAA;AAzpBF","sourcesContent":["// Common App CSS\n\n/* styles.scss */\n@import './variables.css';\n\n.rootElement {\n  min-height: 92vh !important;\n}\n\n// Datatable font size\n.ePLeEU {\n  font-size: 13px !important;\n}\n\n.overview-padding-left {\n  padding-left: 10px !important;\n}\n\n.rdt_TableHeadRow {\n  font-size: 15px !important;\n}\n\n#html5-qrcode-button-camera-permission {\n  padding: 18px;\n  background-color: #f7eeee;\n  border-radius: 8px;\n}\n\n.rounded-pill {\n  height: 20px !important;\n  width: 20px !important;\n}\n\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: var(--login-background-overlay-color);\n}\n\n.fw-datatable-row {\n  font-weight: 500;\n  font-size: 13px;\n  color: var(--login-header-text-color);\n}\n\n.fw-bold-m {\n  font-weight: bold;\n}\n\n.qc-sign-1 {\n  width: 170px;\n  height: 80px;\n  margin-bottom: 25px;\n}\n\n.qc-sign-2 {\n  width: 140px;\n  height: 80px;\n  margin-bottom: 25px;\n}\n\n\n.loginBackground {\n\n  .innerLoginBox {\n    border-radius: 10px;\n    margin-top: 20vh;\n\n  }\n\n  .card-title,\n  label {\n    color: #000;\n  }\n\n  .title {\n    color: var(--login-header-text-color);\n    text-align: center;\n    font-size: 40px;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;\n    z-index: 999;\n  }\n\n  .btn {\n    font-weight: 600 !important;\n    --bs-btn-disabled-opacity: 0.45 !important;\n\n    .btn:disabled {\n      opacity: 0.4 !important;\n    }\n  }\n\n  @media (max-width: 480px) {\n    .card {\n      height: 590px;\n      width: 400px;\n      padding: 16px;\n      background: var(--login-card-background-color) !important;\n    }\n  }\n\n  /* For larger mobile screens and small tablets */\n  @media (min-width: 481px) and (max-width: 767px) {\n    .card {\n      height: 590px;\n      width: 570px;\n      padding: 16px;\n      background: var(--login-card-background-color) !important;\n    }\n  }\n\n  /* For larger tablets and desktops */\n  @media (min-width: 768px) and (max-width: 1200px) {\n    .card {\n      height: 590px;\n      width: 570px;\n      padding: 16px;\n      background: var(--login-card-background-color) !important;\n    }\n  }\n\n  @media (min-width: 1250px) {\n    .card {\n      height: 590px;\n      width: 540px;\n      padding: 16px;\n      background: var(--login-card-background-color) !important;\n    }\n  }\n\n  .deviceId {\n    margin-top: 28px;\n    margin-bottom: 0;\n    font-weight: 600;\n    font-size: 14px;\n    color: #334155;\n\n    display: flex;\n    align-items: center;\n    gap: 8px;\n\n    span {\n      padding: 4px 14px;\n      border-radius: 12px;\n\n      color: #fff;\n      font-weight: 700;\n      letter-spacing: 0.5px;\n\n      background: linear-gradient(135deg,\n          #273167,\n          #273167,\n          #273167);\n\n      background-size: 300% 300%;\n\n      box-shadow:\n        0 4px 12px #27316765,\n        0 0 15px #2731675d;\n\n      animation: deviceBadgeGlow 4s ease infinite;\n    }\n  }\n\n\n  .login-button {\n    display: flex;\n    top: 25px;\n    position: relative;\n\n    button {\n      border-radius: 2px !important;\n      padding: 15px;\n      width: 240px;\n      margin: 5px;\n      background-color: #0047ab;\n    }\n  }\n\n  .header {\n    background-color: #131834;\n    box-shadow: -1px -4px 10px 4px white;\n  }\n\n  .headerTitle {\n    font-size: 30px;\n    padding: 2px 18px !important;\n    margin: 0px;\n    font-weight: 600;\n    color: #fff;\n  }\n\n  .subTitle {\n    font-size: 14px;\n    padding: 0px 2px !important;\n    margin-bottom: 0px;\n    font-weight: 600;\n    color: #57ef82;\n    display: block;\n  }\n\n  .headerLogo {\n    width: 60px;\n    border-radius: 6px;\n    display: inline;\n    margin-right: 14px;\n  }\n\n  .loingFont {\n    font-size: 18px;\n  }\n\n  // .showhideImg{\n  //   display: block;\n  // }\n}\n\n// Mobile\n/* Extra small devices (phones, 600px and down) */\n@media only screen and (max-width: 600px) {\n\n  .loginBackground {\n    .headerTitle {\n      font-size: 30px;\n    }\n\n    .subTitle {\n      font-size: 12px;\n    }\n  }\n\n  .btnTable {\n    margin-top: 10px !important;\n    width: 100% !important;\n  }\n\n  .btnSpaceInMobile {\n    padding: 6px !important;\n  }\n}\n\n@keyframes bounce {\n\n  0%,\n  20%,\n  50%,\n  80%,\n  100% {\n    transform: translateY(0);\n  }\n\n  40% {\n    transform: translateY(-30px);\n  }\n\n  60% {\n    transform: translateY(-15px);\n  }\n}\n\n.bounce {\n  animation: bounce 8s infinite;\n}\n\n// ------------------------------------------------------------------------- //\n\n// Common text logo Color\n.supplier_app {\n  font-family: sans-serif, \"Helvetica Neue\", \"Lucida Grande\", Arial;\n  color: #fff !important;\n}\n\n.supplier_app1 {\n  font-family: sans-serif, \"Helvetica Neue\", \"Lucida Grande\", Arial;\n  color: #143ba6 !important;\n}\n\n\n.eyeCss {\n  border: 0px;\n}\n\n.timmer {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 0px 13px;\n  margin-bottom: 26px;\n  font-size: 14px;\n}\n\n.timmer2 {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 0px 13px;\n  margin-bottom: 8px;\n  font-size: 12px;\n\n  span {\n    font-weight: bold;\n  }\n}\n\n// Common Background Color\nbody {\n  //background-image: linear-gradient(45deg, rgba(255, 255, 255, 1), rgba(252, 245, 246, 1), rgba(254, 254, 254, 1), rgba(235, 236, 238, 1), rgba(225, 227, 229, 1)) !important;\n  // min-height: 100vh!important;\n  background-color: #fff;\n}\n\nbutton {\n  cursor: pointer !important;\n}\n\n.collapse {\n  visibility: initial !important;\n}\n\n// Common Button Color\n\n.btn {\n  // background: var(--btn-color) !important;\n  // color: var(--btn-text-color) !important;\n  // border-color: var(--btn-border-color) !important;    \n  border: 1px solid;\n  border-radius: 8px !important;\n\n  i {\n    color: var(--btn-text-color) !important;\n  }\n}\n\n.btn:hover {\n  //background: var(--btn-hover-color) !important;\n}\n\n.btnTable {\n  background: var(--btn-table-color) !important;\n  color: var(--btn-table-text-color) !important;\n  border-color: var(--btn-table-border-color) !important;\n  border: 1px solid;\n  border-radius: 5px !important;\n  font-size: 14px !important;\n  padding: 8px;\n  width: 90%;\n\n  i {\n    color: var(--btn-table-text-color) !important;\n  }\n}\n\n.btnTable:hover {\n  background: var(--btn-table-hover-color) !important;\n}\n\n.btnTable:disabled {\n  opacity: 0.65;\n}\n\n.btnInfo {\n  background: var(--btn-table-color) !important;\n  border-color: var(--btn-table-border-color) !important;\n  color: var(--btn-table-text-color) !important;\n  border-radius: 20px !important;\n  font-size: 12px !important;\n  padding: 8px;\n  border: 1px solid;\n  width: 200px;\n}\n\n.btnInfo:hover {\n  background: var(--btn-table-hover-color) !important;\n}\n\n.btn:disabled {\n  opacity: 0.4 !important;\n}\n\n.btnBack {\n  background: var(--btn-table-color) !important;\n  border-color: var(--btn-table-border-color) !important;\n  color: var(--btn-table-text-color) !important;\n  border-radius: 20px !important;\n  font-size: 14px !important;\n  padding: 8px;\n  border: 1px solid #13183424;\n  width: 200px;\n}\n\n.btnBack:hover {\n  background: var(--btn-table-hover-color) !important;\n}\n\n.close-btn {\n  font-size: 20px;\n  color: #919191;\n  cursor: pointer;\n}\n\n.close-btn:hover {\n  color: #000;\n}\n\n.statusColor {\n  color: #007FFF !important;\n}\n\n.iconTable {\n  font-size: 20px;\n  padding-right: 8px;\n  cursor: pointer;\n}\n\n.iconTable:hover {\n  font-size: 22px;\n  color: var(--header-background-color);\n}\n\n// Common Delete/Approve Button Color\n.btnCommon {\n  border-radius: 20px !important;\n  color: #000;\n  font-size: 14px !important;\n  padding: 8px;\n  width: 200px;\n  margin-right: 6px;\n  font-weight: 600;\n}\n\n// Delete\n.btn-danger {\n  background-color: #fd071f !important;\n  border-color: #fd071f !important;\n  color: #fff !important;\n}\n\n.btn-danger:hover {}\n\n// Approve\n.btn-approve {\n  background: linear-gradient(1deg,\n      #22c55ea9,\n      #22c55e,\n      #22c55ea9) !important;\n  border-color: #059c3c !important;\n  color: #000000 !important;\n}\n\n.btn-approve:hover {\n  background: linear-gradient(359deg,\n      #22c55e,\n      #22c55ea9,\n      #22c55e) !important;\n}\n\n.badgeExtra {\n  color: #1c1b1b !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n}\n\n.btn:focus {\n  box-shadow: none !important;\n}\n\n.bg-success-wh {\n  background-color: #22c55e !important;\n}\n\n.success {\n  color: #22c55e !important;\n}\n\n.danger {\n  color: #cf0000 !important;\n}\n\n.bg-secondary-wh {\n  background-color: #bebbbb !important;\n}\n\n// Table Status\n.bg-table-status {\n  font-weight: 700;\n  padding: 4px 14px;\n  border-radius: 50px;\n  width: 100%;\n  text-align: center;\n  // text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.bg-table-documentNumber-status {\n  color: #fff;\n  background-color: #273167;\n}\n\n.bg-table-success-status {\n  color: #008000;\n  background-color: #228b223b;\n}\n\n.bg-table-danger-status {\n  color: #f30e2d;\n  background-color: #f30e2d3b;\n}\n\n.bg-table-dark-danger-status {\n  color: #ffffff;\n  background-color: #f30e2d;\n}\n\n.bg-table-warning-status {\n  color: #F17C1A;\n  background-color: #f17b1a42;\n}\n\n.bg-table-info-status {\n  color: #555555b2;\n  background-color: #55555523;\n}\n\n.bg-table-progress-status {\n  color: #FF8C00;\n  background-color: #ffbf0044;\n}\n\n.bg-table-new-status {\n  color: #002387;\n  background-color: #0024873b;\n}\n\n.bg-table-first-status {\n  color: #577766;\n  background-color: #85b09a42;\n}\n\n.bg-table-second-status {\n  color: #3f7d99;\n  background-color: #89cff046;\n}\n\n.bg-table-text-status {\n  color: #323232;\n  background-color: #63c97f57;\n}\n\n.bg-card-active-status {\n  color: #36da36;\n}\n\n.bg-card-inactive-status {\n  color: #f30e2d;\n}\n\n.bg-table-headerTag-status {\n  color: #3b2a6b;\n  background-color: #d7ddff;\n}\n\n.bg-table-headerTag-dev-status {\n  color: #3b2a6b;\n  background-color: #FFEF00;\n}\n\n.bg-table-documentNumber-status {\n  color: #fff;\n  background-color: #273167;\n}\n\n// Workflow\n.bg-status {\n  font-weight: 700;\n  padding: 4px 16px;\n  border-radius: 50px;\n  width: 100%;\n  text-align: center;\n  letter-spacing: 0.5px;\n  margin-bottom: 4px;\n  // text-transform: uppercase;\n}\n\n.bg-success-workflow {\n  color: #000000;\n  background-color: #29c929c9;\n}\n\n.bg-danger-workflow {\n  color: #000000;\n  background-color: #f30e2ddf;\n}\n\n.bg-warning-workflow {\n  color: #F17C1A;\n  background-color: #f17b1ac3;\n}\n\n.bg-info-workflow {\n  color: #555555b2;\n  background-color: #555555b9;\n}\n\n.bg-pending-workflow {\n  color: #FF8C00;\n  background-color: #ffbf00c4;\n}\n\n.bg-complete-workflow {\n  color: #fff;\n  background-color: #138808;\n}\n\n.bg-submit-workflow {\n  color: #007BA7;\n  background-color: #B9D9EB;\n}\n\n.bg-new-workflow {\n  color: #fff;\n  background-color: #0000FF;\n}\n\n.headerStatusDetailedPage {\n  position: relative;\n  font-size: 16px;\n  padding: 5px 17px;\n  margin-left: 16px;\n  top: -4px;\n}\n\n.headerStatusTag {\n  position: relative;\n  font-size: 14px;\n  padding: 4px 16px;\n  margin-left: 16px;\n  letter-spacing: 1px;\n  border-radius: 6px;\n}\n\n.workflow-remark {\n  border: 1px solid #afa8a8;\n  padding: 10px;\n  border-radius: 5px;\n  border-style: dashed;\n  font-size: 12px;\n  font-weight: 600;\n  color: #1c449c;\n}\n\n//radio button\n.form-check-input:checked {\n  background-color: var(--radio--background-color) !important;\n  border-color: var(--radio--border-color) !important;\n}\n\n.tooltip-inner {\n  background-color: #fff !important;\n  color: #000 !important;\n  border: 1px solid #8c8f9580 !important;\n  max-width: 500px !important;\n  width: 300px !important;\n  font-size: 16px !important;\n  text-align: left !important;\n  box-shadow: 0px 0px 3px 0px gray;\n\n  p {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n\n  .itemName {\n    font-size: 16px;\n    font-weight: 600;\n  }\n\n  .textPros {\n    font-size: 12px;\n    font-weight: 400;\n    text-align: right;\n  }\n\n  .rowBorder {\n    border-bottom: 1px dashed #858484;\n  }\n}\n\n.tooltip.show {\n  opacity: initial !important;\n}\n\n// Leftmenu\n.sidebar-nav .nav-heading {\n  font-size: 14px;\n  text-transform: uppercase;\n  color: #000000;\n  font-weight: 600;\n  margin: 12px 0 5px 0px;\n}\n\n// Event Details -> accordion\n.accordion-button:focus {\n  box-shadow: none !important;\n}\n\n.accordion-button:not(.collapsed) {\n  background-color: #ffffff !important;\n}\n\n.accordion-header {\n  margin-left: 0px;\n  margin-right: 0px;\n}\n\n.accordion-item {\n  .headerTitle {\n    display: block;\n    font-size: 17px;\n    font-weight: bold;\n    padding-bottom: 4px;\n  }\n\n  .subHeaderTitle {\n    display: block;\n    font-size: 14px;\n    font-weight: 400;\n  }\n}\n\n.accordion {\n  .refreshIcon {\n    width: 80px;\n    text-align: end;\n    font-size: 20px;\n    cursor: pointer;\n  }\n\n  .refreshIcon:hover {\n    font-size: 22px;\n  }\n\n  .dropdown-menu.show {\n    position: absolute !important;\n    inset: 30px 0px auto -122px !important;\n    margin: 0 !important;\n    transform: translate(0, 0) !important;\n  }\n}\n\n.commonFooter {\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  color: #fff;\n  text-align: center;\n  padding: 20px 0;\n  margin-left: -2%;\n}\n\n.rowDirection {\n  flex-direction: row-reverse;\n}\n\n.headerIcon {\n  font-size: 18px;\n  cursor: pointer;\n}\n\n.headerIcon:hover {\n  color: #ceaef7;\n}\n\n.iconLogo {\n  background: var(--table-icon-background-color) !important;\n  font-size: 20px;\n  color: var(--table-icon-text-color);\n  border: 1px solid rgba(0, 0, 0, 0.11);\n  border-radius: 4px;\n  width: 44px;\n  display: block;\n  padding: 5px 0px;\n}\n\n// Common cards color\n.qr-code {\n  .qr-code-navbar button {\n    float: right;\n    right: 10px;\n  }\n\n  .card {\n    img {\n      height: 140px;\n      border-bottom: 1px solid #0047ab;\n    }\n\n    margin:10px;\n\n    .card-title {\n      text-align: center;\n      position: relative;\n      color: #0047ab;\n      font-weight: 700;\n    }\n\n    .user-role {\n      text-align: center;\n      position: relative;\n    }\n\n    .user-qr-code {\n      //left: 23%;\n      position: relative;\n      margin-left: auto;\n      margin-right: auto;\n      width: 50%;\n      display: table;\n    }\n  }\n}\n\n/* Ensure the table has borders and takes up the full width */\n.jobcard-content-table {\n  width: 100%;\n  /* Ensure the table takes up the full width of its parent */\n  border-collapse: collapse;\n  /* Collapse borders to make it cleaner */\n  //margin-bottom: 20px; /* Add space between the table and the next column */\n}\n\n.jobcard-detail-table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n  /* Equal column widths */\n  font-size: 13px;\n\n  th,\n  td {\n    border: 2px solid #000;\n    padding: 4px;\n    word-wrap: break-word;\n    text-align: left;\n    height: 50px;\n    line-height: 20px;\n  }\n\n  th:first-child,\n  td:first-child {\n    width: 16%;\n    /* First column gets more space */\n  }\n\n  th:not(:first-child),\n  td:not(:first-child) {\n    width: 10%;\n    /* Adjust based on how many columns you have */\n  }\n\n  tr:not(:first-child) {\n    line-height: 30px;\n  }\n}\n\n.report-title-line {\n  display: flex !important;\n  flex-direction: row !important;\n  justify-content: space-between;\n  width: 100%;\n  white-space: nowrap;\n  margin-top: 5px;\n}\n\n.report-title-line>div {\n  flex: 1;\n  padding: 0;\n  margin: 0;\n  text-align: left;\n}\n\n.report-title-line>div:last-child {\n  text-align: right;\n}\n\n\n.telma-header {\n  text-align: center;\n  text-decoration: underline;\n}\n\n.telma-detail {\n  display: block;\n  text-align: center;\n  width: 100%;\n}\n\n.jobcard-singlerow {\n  text-align: center !important;\n}\n\n.jobcard-content-table td,\n.jobcard-content-table th {\n  border: 2px solid #000000;\n  /* Add a border to table cells */\n  padding: 5px 8px;\n  /* Add padding to make the content more readable */\n  text-align: left;\n  /* Align text to the left in table cells */\n}\n\n/* Styling for bold table content */\n.jobcard-content-bold {\n  font-weight: bold;\n  color: #0047ab;\n  /* Optional: Add color for bold content */\n}\n\n/* Ensure the content in the second column is centered */\n.jobcard-content-column {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n\n/* Card Title Styling */\n.jobcard-priority {\n  color: #0047ab !important;\n  /* Default priority color */\n  text-align: center;\n  font-weight: bold;\n  font-weight: bold !important;\n}\n\n.jobcard-priority-urgent {\n  color: red !important;\n  /* Priority 'urgent' color */\n  text-align: center;\n  font-weight: bold;\n  font-weight: bold !important;\n}\n\n/* Styling for QR code */\n.jobcard-content-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n}\n\n.jobcard-content-table td,\n.jobcard-content-table th {\n  border: 2px solid #000000;\n  padding: 5px 8px;\n  text-align: left;\n}\n\n.jobcard-content-bold {\n  font-weight: bold;\n  color: #0047ab;\n}\n\n.qr-code-cell {\n  width: 120px;\n  /* Set width for the QR code cell */\n  text-align: center;\n  /* Center the QR code inside the cell */\n}\n\n.jobcard-qr-code {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0 5px;\n}\n\n.jobcard-qr-code img {\n  width: 100%;\n  height: auto;\n}\n\n.jobcard-title-content {\n  text-align: center !important;\n  font-weight: bold;\n  color: #0047ab;\n  margin-bottom: 2px;\n}\n\n.jobcard-title-content-jobcard {\n  margin-top: 10px;\n  text-align: center !important;\n  font-weight: bold;\n  color: #0047ab;\n}\n\n\n// .jobcard-qr-code {\n//   width: 80%;\n//   height: 55%;\n//   display: flex;\n//   justify-content: center;\n//   align-Items: center;\n//   margin-left: auto;\n//   margin-right: auto;\n\n// }\n\n// .jobcard-content-bold {\n//   margin-bottom: 5px;\n//   font-weight: bold;\n// }\n\n// .jobcard-content {\n//   margin-bottom: 0px;\n// }\n\n// .jobcard-priority {\n//   margin-top: 10px !important;\n//   color: #0047ab;\n// }\n\n// .jobcard-priority-urgent {\n//   margin-top: 10px !important;\n//   color: red !important;\n// }\n\n// .jobcard-title-content {\n//   display: flex;\n//   justify-content: center;\n//   align-Items: center;\n//   margin-left: auto;\n//   margin-right: auto;\n// }\n\n// @media print {\n\n//   /* Your print-specific styles here */\n//   .qr-code {\n//     .qr-code-navbar button {\n//       float: right;\n//       right: 10px;\n//     }\n\n//     .card {\n//       img {\n//         height: 140px;\n//         border-bottom: 1px solid #0047ab;\n//       }\n\n//       margin:10px;\n\n//       .card-title {\n//         text-align: center;\n//         position: relative;\n//         color: #0047ab;\n//         font-weight: 700;\n//       }\n\n//       .user-role {\n//         text-align: center;\n//         position: relative;\n//       }\n\n//       .user-qr-code {\n//         //left: 23%;\n//         position: relative;\n//         margin-left: auto;\n//         margin-right: auto;\n//         width: 50%;\n//         display: table;\n//       }\n//     }\n//   }\n// }\n\n// Common input textfield color\ninput[type=\"text\"],\ninput[type=\"number\"],\ninput[type=\"date\"],\ninput[type=\"password\"],\ninput[type=\"email\"],\n.rw-widget-picker {\n  background-color: #ffffffe3 !important;\n  border-radius: 8px !important;\n  font-size: 14px !important;\n  height: 42px;\n  border: var(--bs-border-width) solid var(--bs-border-color)\n}\n\ninput[type=\"checkbox\"] {\n  height: 20px;\n  width: 20px;\n  border: 1px solid #B8B8B8 !important;\n}\n\ninput[type=\"number\"]:disabled {\n  background: #e8e8e8 !important;\n  font-weight: 600;\n  color: var(--textbox-disabled-text-color);\n}\n\n// Common font style and color\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nspan,\nlabel,\na,\ndiv {\n  font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\",\n    \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\",\n    \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !important;\n  color: var(--app-text-color);\n}\n\n.is-invalid {\n  .rw-widget-picker {\n    border: 1px solid var(--bs-form-invalid-border-color) !important;\n  }\n}\n\n.dropdownHive {\n  input[type=text] {\n    // background-color: transparent !important;\n    border-radius: 2px !important;\n    font-size: 14px !important;\n    border: 0px solid rgb(195, 185, 185) !important;\n  }\n\n\n  .rw-widget-picker {\n    min-height: 42px;\n    border-radius: 8px;\n  }\n\n  .rw-list-option.rw-state-selected,\n  .rw-state-selected.rw-list-option-create {\n    background-color: #aaa8a8;\n    border-color: #aaa8a8;\n    color: #fff;\n  }\n}\n\n.dropdownHiveOption {\n  z-index: 9999;\n}\n\n.jobcardYearPicker {\n  width: 100%;\n}\n\n.jobcardYearPickerControl {\n  align-items: center;\n  background: #fff;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  display: flex;\n  min-height: 42px;\n  overflow: hidden;\n  width: 100%;\n\n  input {\n    background: transparent;\n    border: 0;\n    cursor: pointer;\n    flex: 1;\n    font-size: 14px;\n    min-width: 0;\n    outline: 0;\n    padding: 0 12px;\n  }\n\n  button {\n    align-items: center;\n    align-self: stretch;\n    background: transparent;\n    border: 0;\n    color: #657482;\n    display: flex;\n    justify-content: center;\n    padding: 0 12px;\n  }\n}\n\n.dropdownIcon {\n  top: 23px;\n}\n\n.form-label {\n  font-weight: 600;\n  font-size: 14px;\n}\n\na {\n  text-decoration: none !important;\n}\n\n// a:hover{\n//   color: #6476d9  !important;\n// }\n.subText {\n  font-size: 14px;\n}\n\n.form-signin {\n  text-align: center;\n  margin-top: 22px;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.text-indigo-600 {\n  --tw-text-opacity: 1;\n  color: rgb(79 70 229 / var(--tw-text-opacity)) !important;\n}\n\n/* width */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #bec4c4;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/* ===== Scrollbar CSS ===== */\n/* Firefox */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: #bebbbb #ffffff;\n}\n\n/* Chrome, Edge, and Safari */\n*::-webkit-scrollbar {\n  width: 16px;\n}\n\n*::-webkit-scrollbar-track {\n  background: #ffffff;\n}\n\n*::-webkit-scrollbar-thumb {\n  background-color: #bebbbb;\n  border-radius: 10px;\n  border: 3px solid #ffffff;\n}\n\n.arrowBtn {\n  width: 50px !important;\n}\n\n.logoBtn {\n  width: 70px !important;\n}\n\n// Header and Line Item Display Screen\n.headerText {\n  font-weight: 600;\n  font-size: 16px;\n  margin-right: 4px;\n  display: block;\n}\n\n.headerSubText {\n  font-size: 16px;\n}\n\n.deleteIconAccordion {\n  float: inline-end;\n  margin-top: -40px;\n\n  i {\n    font-size: 24px;\n    color: red;\n    cursor: pointer;\n  }\n\n  i:hover {\n    font-size: 26px;\n  }\n}\n\n.infoIconAccordion {\n  i {\n    font-size: 18px;\n    color: rgb(24, 33, 121);\n    cursor: pointer;\n  }\n}\n\n.dynamicDropdown {\n  .rw-popup-container {\n    padding: 0px !important;\n    position: static !important;\n  }\n}\n\n.numberFormate {\n  width: 100%;\n  text-align: end;\n}\n\n\n// Common Ends here\n// ------------------------------------------------------------------------- //\n\n.sectionArea {\n  box-shadow: 0px 20px 40px 9px rgba(0, 0, 0, 0.295);\n}\n\n.navMenu {\n  font-weight: 400 !important;\n  text-transform: uppercase;\n}\n\n.supplier_app {\n  font-family: sans-serif, \"Helvetica Neue\", \"Lucida Grande\", Arial;\n  font-size: 34px;\n}\n\n.feature {\n  .learnMore {\n    padding: 7px;\n    background: #ff3434;\n    color: #ffffff;\n    font-weight: 600;\n    letter-spacing: 1px;\n  }\n\n  .textBox {\n    border-left-width: 18px;\n    height: 325px;\n    padding-top: 35px;\n    margin-right: 7%;\n    padding-left: 38px;\n    text-align: justify;\n  }\n}\n\n.h2 {\n  margin-top: 0;\n  margin-bottom: 25px;\n  font-size: 60px;\n  line-height: 120%;\n  color: #e3f2ff;\n\n  .headline-emphasis-red {\n    color: #e04b4d;\n    font-family: Georgia, Times, Times New Roman, serif;\n    font-style: italic;\n    font-weight: 400;\n  }\n}\n\n.cta {\n  margin-top: 0;\n  margin-bottom: 25px;\n  font-size: 40px;\n  line-height: 120%;\n\n  .headline-emphasis-gold {\n    color: #c4a27f;\n    font-family: Georgia, Times, Times New Roman, serif;\n    font-style: italic;\n    font-weight: 400;\n  }\n}\n\n.staffed {\n  margin-top: 0;\n  margin-bottom: 25px;\n  font-size: 45px;\n  line-height: 160%;\n  color: #410641;\n}\n\n.ctaFindButton {\n  background-color: #fb00009c !important;\n}\n\n.ctaFindButton:hover {\n  background-color: #ff0000 !important;\n}\n\n.text-lgColor {\n  color: #71b7b7;\n}\n\n.text-xlColor {\n  color: #f7f7f7;\n}\n\n// Footer\n.footer {\n  .workersHiveFooter {\n    text-align: right;\n    position: absolute;\n    padding-top: 1%;\n  }\n}\n\n// Navbar\n.navBackground {\n  background-color: #131834;\n}\n\n// Login\n.loginPage {\n  background-color: #ffffff;\n  background-image: -webkit-linear-gradient(278deg, #f3f3f3 65%, #ffffff 50%);\n\n  .loadSingIn {\n    animation: bounce-in 1s ease-in;\n  }\n\n  .loadReset {\n    animation: bounce-out 1s ease-in;\n  }\n\n  @keyframes bounce-in {\n    0% {\n      opacity: 0;\n      transform: scale(0.5);\n    }\n\n    100% {\n      opacity: 1;\n      transform: scale(1);\n    }\n  }\n\n  @keyframes bounce-out {\n    0% {\n      opacity: 1;\n      transform: scale(1);\n    }\n\n    100% {\n      opacity: 0;\n      transform: scale(0.5);\n    }\n  }\n\n  .indexValue {\n    z-index: 5;\n  }\n\n  .mainTitle {\n    font-weight: 700;\n    letter-spacing: 1px;\n    margin-bottom: 18px;\n    margin-top: 15px;\n    color: #dc0000;\n    text-align: center;\n  }\n\n  .box2 {\n    border: 1px solid #dbd6d6;\n    border-radius: 3px;\n    box-shadow: 0px 7px 20px 3px #b7b6b6;\n    padding: 40px 40px 30px 40px;\n\n    .inputBox {\n      padding-left: 10px;\n    }\n\n    .eyeCss {\n      margin-top: 12px;\n      width: 30px;\n    }\n\n    .mainTitleBox2 {\n      font-size: 20px;\n      color: #313131;\n      margin-top: 6px;\n    }\n\n    .passwordEye {\n      position: absolute;\n      margin-left: -28px;\n      margin-top: 18px;\n    }\n  }\n\n  .footer {\n    margin-top: 0%;\n    float: left;\n    font-size: 14px;\n    font-weight: 600;\n\n    .footerLink {\n      text-decoration: none;\n      color: #2b2a2a;\n      margin-right: 14px;\n    }\n\n    .footerLinkText {\n      margin: 8px 13px 13px 2px;\n      font-size: 12px;\n      font-weight: 500;\n    }\n  }\n\n  .subText {\n    font-size: 13px;\n  }\n\n  .staySingIn {\n    font-size: 14px;\n    font-weight: 600;\n  }\n\n  .removeUnderline {\n    cursor: pointer;\n    text-decoration: none;\n    font-size: 14px;\n    font-weight: 600;\n    color: #0d6efd;\n    float: right;\n    margin-top: -21px;\n  }\n\n  .removeUnderline:hover {\n    color: rgb(220 0 0);\n  }\n\n  .singUp {\n    cursor: pointer;\n    text-decoration: none;\n    font-size: 14px;\n    font-weight: 600;\n    color: #0d6efd;\n  }\n\n  .singUp:hover {\n    color: rgb(220 0 0);\n  }\n\n  .returnSingIn {\n    cursor: pointer;\n    text-align: center;\n    margin-top: 25px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #0d6efd;\n  }\n\n  .returnSingIn:hover {\n    color: rgb(220 0 0);\n  }\n\n  .db-RegisterAndLoginBackground-background {\n    z-index: 0;\n    position: absolute;\n    top: 530px;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    transform: skewY(352deg);\n\n    .db-RegisterAndLoginBackground-firstLeftStripe {\n      background: rgb(220 0 0 / 78%);\n      height: 40px;\n      top: 668px;\n      left: calc(50% - 700px);\n      right: calc(50% + 540px);\n    }\n\n    .db-RegisterAndLoginBackground-secondLeftStripe {\n      background: rgb(13 0 255 / 37%);\n      height: 16px;\n      top: 698px;\n      left: -10px;\n      right: calc(50% + 405px);\n    }\n  }\n}\n\n.login-username {\n  input {\n    border-radius: 2px !important;\n    height: 50px;\n  }\n}\n\n.mailConfirmation {\n  // background-color: #ffffff;\n  // background-image: -webkit-linear-gradient(275deg, #f3f3f3 65%, #ffffff 50%);\n\n  .confirmIcon {\n    font-size: 100px;\n    position: absolute;\n    color: #00d700;\n    margin-top: -56px;\n    margin-left: -42px;\n  }\n\n  .mainTitle {\n    font-weight: 700;\n    letter-spacing: 1px;\n    margin-bottom: 18px;\n    margin-top: 15px;\n    color: #dc0000;\n    text-align: center;\n  }\n\n  .box2 {\n    border: 1px solid #dbd6d6;\n    border-radius: 3px;\n    box-shadow: 0px 7px 20px 3px #b7b6b6;\n    padding: 90px 40px 30px 40px !important;\n\n    .mainContent {\n      text-align: center;\n      font-size: 26px;\n      font-weight: bold;\n    }\n\n    .subContent {\n      text-align: center;\n      font-size: 15px;\n      font-weight: 600;\n      margin-bottom: 32px;\n    }\n\n    .inputBox {\n      padding-left: 10px;\n    }\n\n    .eyeCss {\n      margin-top: 12px;\n      width: 30px;\n    }\n\n    .mainTitleBox2 {\n      font-size: 20px;\n      color: #313131;\n      margin-top: 6px;\n    }\n\n    .passwordEye {\n      position: absolute;\n      margin-left: -28px;\n      margin-top: 18px;\n    }\n  }\n\n  .footer {\n    margin-top: 30px;\n    float: left;\n    font-size: 14px;\n    font-weight: 600;\n\n    .footerLink {\n      text-decoration: none;\n      color: #2b2a2a;\n      margin-right: 14px;\n    }\n\n    .footerLinkText {\n      margin: 8px 13px 13px 2px;\n      font-size: 12px;\n      font-weight: 500;\n    }\n  }\n\n  .db-RegisterAndLoginBackground-background {\n    z-index: 0;\n    position: absolute;\n    top: 530px;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    transform: skewY(352deg);\n\n    .db-RegisterAndLoginBackground-firstLeftStripe {\n      background: rgb(220 0 0 / 78%);\n      height: 40px;\n      top: 668px;\n      left: calc(50% - 700px);\n      right: calc(50% + 540px);\n    }\n\n    .db-RegisterAndLoginBackground-secondLeftStripe {\n      background: rgb(13 0 255 / 37%);\n      height: 16px;\n      top: 698px;\n      left: -10px;\n      right: calc(50% + 405px);\n    }\n  }\n}\n\n// Register\n.registerPage {\n\n  // padding-top: 50px;\n  // background-color: #ffffff;\n  // background-image: -webkit-linear-gradient(278deg, #f3f3f3 65%, #ffffff 50%);\n  .fieldErrMsg {\n    font-size: 12px;\n    color: #f32525 !important;\n  }\n\n  .indexValue {\n    z-index: 5;\n  }\n\n  .logo {\n    width: 150px;\n  }\n\n  .mainTitle {\n    font-weight: 700;\n    letter-spacing: 1px;\n    margin-bottom: 30px;\n    margin-top: -36px;\n  }\n\n  .mainTitleSm {\n    font-weight: 700;\n    letter-spacing: 1px;\n    margin-bottom: 32px;\n    margin-top: 40px;\n    color: #dc0000;\n    text-align: center;\n  }\n\n  .box1 {\n    .boxTitle {\n      font-size: 16px;\n      font-weight: 600;\n      margin-top: 7px;\n    }\n\n    .subBoxTitle {\n      font-size: 14px;\n      font-weight: 500;\n    }\n  }\n\n  .box2 {\n    border: 1px solid #dbd6d6;\n    border-radius: 3px;\n    box-shadow: 0px 7px 20px 3px #b7b6b6;\n    padding: 40px 40px 30px 40px;\n\n    .inputBox {\n      padding-left: 10px;\n    }\n\n    .eyeCss {\n      margin-top: 12px;\n      width: 30px;\n    }\n\n    .mainTitleBox2 {\n      color: #313131;\n      margin-top: 6px;\n    }\n  }\n\n  .footer {\n    margin-top: 12%;\n    float: left;\n    font-size: 14px;\n    font-weight: 600;\n\n    .footerLink {\n      text-decoration: none;\n      color: #2b2a2a;\n      margin: 13px;\n    }\n\n    .footerLinkText {\n      margin: 3px 13px 13px 15px;\n      font-size: 12px;\n      font-weight: 500;\n    }\n  }\n\n  .singIn {\n    text-decoration: none;\n  }\n\n  .db-RegisterAndLoginBackground-background {\n    z-index: 0;\n    position: absolute;\n    top: 530px;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    transform: skewY(352deg);\n\n    .db-RegisterAndLoginBackground-firstLeftStripe {\n      background: rgb(220 0 0 / 78%);\n      height: 40px;\n      top: 668px;\n      left: calc(50% - 700px);\n      right: calc(50% + 540px);\n    }\n\n    .db-RegisterAndLoginBackground-secondLeftStripe {\n      background: rgb(13 0 255 / 37%);\n      height: 16px;\n      top: 698px;\n      left: -10px;\n      right: calc(50% + 405px);\n    }\n  }\n}\n\n// auto scroll direction UP side\n\n\n.status-col-wrapper {\n  width: 100%;\n  max-width: 500px;\n  /* Adjust as needed */\n  height: 92rem;\n  /* Adjust height to show about 6 cards */\n  overflow: hidden;\n  margin: 0 auto;\n  border-radius: 16px;\n  box-shadow: 0 2px 8px 0 rgba(80, 120, 180, 0.04);\n  background: #fff;\n}\n\n.status-col {\n  display: flex;\n  flex-direction: column;\n  gap: 0px;\n  animation: scroll-up 16s linear infinite;\n}\n\n.status-col:hover {\n  animation-play-state: paused;\n}\n\n/* Adjust the -50% based on card count/height! */\n@keyframes scroll-up {\n  0% {\n    transform: translateY(0);\n  }\n\n  100% {\n    transform: translateY(-10%);\n  }\n}\n\n\n.machine-overview-card {\n  margin: 20px;\n  padding: 0px !important;\n\n  box-shadow: 0 2px 8px 0 rgba(80, 120, 180, 0.08);\n  border-radius: 16px;\n  margin-bottom: 0;\n\n  .card-body {\n    padding: 10px;\n    border: 1px solid #0023872b;\n    border-radius: 4px;\n  }\n\n  .status-row {\n    display: flex;\n    gap: 7px;\n    flex-wrap: wrap;\n    align-items: center;\n    font-size: 17px;\n  }\n\n  .chip {\n    display: inline-flex;\n    align-items: center;\n    padding: 0.3em 1em;\n    border-radius: 2em;\n    font-weight: 500;\n    background: #f2f4f8;\n    color: #333;\n    box-shadow: 0 2px 8px 0 rgba(80, 120, 180, 0.04);\n    transition: background 0.2s;\n  }\n\n  .chip-blue {\n    background: #0024873b;\n    color: #002387;\n  }\n\n  .chip-green {\n    background: #228b223b;\n    color: #008000;\n  }\n\n  .chip-red {\n    background: #f30e2d3b;\n    color: #f30e2d;\n  }\n\n  .chip-orange {\n    color: #ac7603;\n    background-color: #ffbf0044;\n  }\n\n}\n\n\n\n.monthly-overview-wrapper {\n  border: 1px solid #ddd;\n  margin-bottom: 12px;\n  margin-right: 10px;\n  font-size: 20px;\n}\n\n.monthly-overview-header {\n  cursor: pointer;\n  padding: 10px 15px;\n  background: #f7f7f7;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.toggle-arrow {\n  transition: transform 0.25s ease-in-out;\n}\n\n.toggle-arrow.open {\n  transform: rotate(180deg);\n}\n\n.monthly-content {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.35s ease;\n}\n\n.monthly-content.show {\n  max-height: 600px;\n  /* large enough height */\n  padding: 10px 15px;\n}\n\n\n// .monthly-container {\n//   background: #f9fbfc;\n//   padding: 20px;\n//   border-radius: 8px;\n//   border: 1px solid #e6e8ef;\n//   margin-bottom: 20px;\n// }\n\n.section-title {\n  font-weight: 700;\n  margin-bottom: 20px;\n  color: #444;\n}\n\n.monthly-column {\n  padding: 10px 15px;\n\n  .block {\n    background: white;\n    border-radius: 6px;\n    border: 1px solid #dcdcdc;\n    padding: 15px 20px;\n    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);\n    margin: 0px 4px !important;\n  }\n\n  .block-header {\n    padding: 6px 10px;\n    border-radius: 4px;\n    font-weight: 600;\n    margin-bottom: 10px;\n    text-transform: uppercase;\n    font-size: 13px;\n  }\n\n  .block-item {\n    display: flex;\n    justify-content: space-between;\n    padding: 4px 0px;\n    border-bottom: 1px dashed #dedede;\n    font-size: 14px;\n  }\n\n  .block-item:last-child {\n    border-bottom: none;\n  }\n\n  .block-item label {\n    color: #444;\n    font-weight: 500;\n  }\n\n  .block-item span {\n    color: #000;\n    font-weight: 600;\n  }\n\n}\n\n\n\n.urgent-color {\n  background: rgba(243, 14, 45, 0.231372549);\n  color: #f30e2d;\n}\n\n.regular-color {\n  background: #e7efff;\n  color: #1155cc;\n}\n\n\n\n.overview-card {\n  margin: 10px 10px 0 10px;\n  border-radius: 5px !important;\n\n  .card-header {\n    background-color: var(--header-background-color) !important;\n    color: #FFFFFF;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .card-body {\n    padding: 10px !important;\n  }\n\n  .overview-card {\n    padding: 10px;\n    border-radius: 8px;\n  }\n\n  .column-card-heading {\n    display: block;\n    font-size: 15px;\n    font-weight: 700;\n    margin-bottom: 10px;\n  }\n\n  .detail-row {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 4px;\n    font-size: 14px;\n  }\n\n  .left-section {\n    border-right: 1px solid #ddd;\n    padding-right: 20px;\n  }\n\n  .right-section {\n    padding-left: 20px;\n  }\n\n  .dates {\n    border: 1px solid #ebeff2;\n    border-radius: 5px;\n    padding: 10px 0px;\n    margin: 10px 10px;\n    font-size: 16px;\n    color: #5aadef;\n    font-weight: 700;\n    overflow: auto;\n\n    .urgent {\n      font-size: 30px;\n      color: #0d6efd;\n      cursor: pointer;\n    }\n\n    .machines-urgent {\n      font-size: 20px;\n      color: #0d6efd\n    }\n\n    .regular {\n      font-size: 30px;\n      color: #00d700;\n      cursor: pointer;\n    }\n  }\n\n  .dates div {\n    float: left;\n    width: 50%;\n    text-align: center;\n    position: relative;\n  }\n\n  .dates .machines-urgent {\n    float: left;\n    width: 100%;\n    text-align: center;\n    position: relative;\n  }\n\n  .dates strong,\n  .stats strong {\n    display: block;\n    color: #adb8c2;\n    font-size: 11px;\n    font-weight: 700;\n  }\n\n  .dates span {\n    width: 1px;\n    height: 40px;\n    position: absolute;\n    right: 0;\n    top: 0;\n    background: #ebeff2;\n  }\n\n  .column-card-heading {\n    display: block;\n    color: #adb8c2;\n    font-size: 11px;\n    font-weight: 700;\n    text-align: center;\n  }\n\n  .overview-footer strong,\n  .stats strong {\n    display: block;\n    color: #adb8c2;\n    font-size: 11px;\n    font-weight: 700;\n  }\n\n  .overview-footer div {\n    //width:50%;\n    float: left;\n    text-align: center;\n    position: relative;\n    font-size: 20px;\n    font-weight: 700;\n  }\n\n  .machine-overview-footer div {\n    //width:50%;\n    float: left;\n    text-align: center;\n    position: relative;\n    font-size: 14px;\n    font-weight: 700;\n  }\n\n  .machine-overview-footer strong,\n  .stats strong {\n    display: block;\n    color: #adb8c2;\n    font-size: 11px;\n    font-weight: 700;\n  }\n\n  .reject-quantity {\n    color: red;\n  }\n\n  .overview-card-header-value {\n    float: right;\n    color: #FFFFFF;\n    cursor: pointer;\n  }\n\n  .success-indicator {\n    float: right;\n    filter: drop-shadow(0 0 10px #24ff41) drop-shadow(0 0 30px #0aef2d) drop-shadow(0 0 50px #40e911);\n    background-color: rgb(0 254 136) !important;\n  }\n\n  .error-indicator {\n    float: right;\n    filter: drop-shadow(0 0 5px #ff9898) drop-shadow(0 0 5px #fc8b8b) drop-shadow(0 0 5px #ff5b5b);\n    background-color: #ff0707;\n    animation: glow 1s infinite alternate;\n  }\n\n  @keyframes glow {\n    0% {\n      box-shadow: 0 0 10px red;\n    }\n\n    100% {\n      box-shadow: 0 0 20px red, 0 0 30px red;\n      /* More glow */\n    }\n  }\n\n\n}\n\n// .bg-body-tertiary\n// {\n//   padding: 10px !important;\n//     border-radius: 6px !important;\n//     border: 1px solid #d9d9d9 !important;\n// }\n.searchDropdown {\n  width: 400px;\n}\n\n.jobcard-div {\n  display: flex;\n  padding: 10px;\n  border-radius: 5px;\n}\n\n.machineStatus-card {\n  margin: 20px;\n  border-radius: 5px !important;\n  color: #009845 !important;\n  font-weight: bold;\n  cursor: pointer;\n\n  .active {\n    font-size: 20px;\n\n    color: #009845 !important;\n    border: 2px solid #009845;\n    border-radius: 5px;\n\n    .machineStatus-text {\n      color: #009845 !important;\n      width: 22em;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap;\n    }\n\n    .label {\n      color: #009845 !important;\n      font-weight: bold;\n    }\n  }\n\n  .card-body:hover {\n    background-color: #77a7ee4d;\n  }\n\n  .in-active {\n    font-size: 20px;\n    border: 2px solid #f30e2d;\n    border-radius: 5px;\n    background-color: #ff04043d;\n\n    .machineStatus-text {\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden;\n      width: 22em;\n      color: #f30e2d !important;\n    }\n\n    .label {\n      color: #f30e2d !important;\n      font-weight: bold;\n    }\n  }\n}\n\n.machine-status-form {\n  font-size: 26px;\n\n  .form-check-label {\n    font-size: 16px;\n    padding-top: 6px;\n  }\n\n  .form-check-input {\n    border: 1px solid #000000 !important;\n  }\n}\n\n.back {\n  color: #FFFFFF;\n}\n\n.machineStatusTitle {\n  font-weight: 700;\n  letter-spacing: 1px;\n  margin-top: 10px;\n  margin-left: 36%;\n  margin-right: 32%;\n}\n\n.reworkStatusTitle {\n  font-weight: 700;\n  letter-spacing: 1px;\n  margin-top: 10px;\n  margin-left: 46%;\n  margin-right: 32%;\n}\n\n.submsgTitle {\n  font-weight: 500;\n  letter-spacing: 1px;\n  margin-top: 10px;\n  margin-left: 40%;\n}\n\n.acknowledmentStatus {\n  width: 16%;\n  float: right;\n  position: absolute;\n  top: 13px;\n  left: 82%;\n}\n\n.navigateBackButton {\n  float: left;\n}\n\n.machineIdleHeading {\n  display: flex;\n  justify-content: center;\n  align-Items: center;\n}\n\n.machineIdleLabel {\n  font-weight: 500;\n  font-size: 18px;\n}\n\n.machine-status-footer-button .btn {\n  margin-right: 50px !important;\n  border-radius: 0px !important;\n}\n\n.machineIdleColumn {\n  padding: 10px\n}\n\n.machineIdleRadio {\n  .form-check-label {\n    font-weight: 400;\n  }\n\n  .checkListType {\n    background-color: var(--header-background-color) !important;\n    color: #FFFFFF;\n    align-items: center;\n    font-weight: bold;\n  }\n\n  .checklistSwitch {\n    width: 100% !important;\n    display: table;\n    margin: 1.5em;\n\n    label {\n      font-size: 18px;\n    }\n  }\n}\n\n.w-90 {\n  width: 22em;\n}\n\n.ackQRBase {\n  height: 500px;\n\n}\n\n.jobcard-qrscanner-modal {\n  .manual-jobcard-form {\n    label {\n      padding: 6preportheaderx;\n      font-size: 18px;\n      font-weight: 700;\n    }\n\n    input {\n      width: 50%;\n      padding-left: 5px;\n    }\n  }\n\n  .modal-dialog {\n    .modal-footer {\n      display: inline-block;\n    }\n  }\n}\n\n.ack-toMachine {\n  display: flex;\n\n  #machineCode_input {\n    width: 70%;\n    margin-left: 30px;\n  }\n}\n\n.ack-card {\n  margin-top: 20px !important;\n}\n\n.jobcard-detail-list span {\n  font-weight: bold;\n}\n\n.start-stop-page-header {\n  margin-bottom: 15px;\n}\n\n.reportheader {\n  border: 1px solid #8c8686;\n  border-radius: 8px;\n  padding: 10px 10px 10px 10px;\n  border-style: dashed;\n  margin-bottom: 20px;\n  background-color: #ffffff;\n  box-shadow: 0px 1px 9px 1px #b7b7b7;\n}\n\n.filterbox-btn {\n  align-items: center;\n  display: flex;\n  margin-top: 10px !important;\n\n  button {\n    margin-left: 20px;\n  }\n}\n\n.searchFilter-btn i {\n  font-size: 24px;\n}\n\n// Dashboard Loader\n.loader-small {\n  .loader-sm {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    width: 100%;\n    animation: none;\n  }\n\n  .loader__circle {\n    width: 14px;\n    height: 14px;\n    border-radius: 50%;\n    margin: 0 4px;\n    animation: loader_901 1s ease-in-out infinite;\n  }\n\n  .loader__circle:nth-of-type(1) {\n    background-color: #007aff;\n    animation-delay: 0;\n  }\n\n  .loader__circle:nth-of-type(2) {\n    background-color: #ff2d55;\n    animation-delay: 0.25s;\n  }\n\n  .loader__circle:nth-of-type(3) {\n    background-color: #34c759;\n    animation-delay: 0.5s;\n  }\n\n  .loader__circle:nth-of-type(4) {\n    background-color: #ff9500;\n    animation-delay: 0.75s;\n  }\n\n  @keyframes loader_901 {\n    0% {\n      transform: scale(1);\n    }\n\n    20% {\n      transform: scale(1.2);\n    }\n\n    40% {\n      transform: scale(1);\n    }\n  }\n}\n\n\n.order-conf-footer {\n  padding: 0px !important;\n\n  button {\n    width: 100% !important;\n    border-radius: 0px !important;\n  }\n}\n\n.oc-header-right {\n  float: right;\n  text-align: right;\n\n  .column-card-heading {\n    font-size: 18px;\n  }\n}\n\n.oc-header-left {\n  .column-card-heading {\n    font-size: 18px;\n  }\n}\n\n.oc-header-value {\n  font-size: 22px;\n  color: #858484\n}\n\n.popupInputField input {\n  width: 100px;\n  padding-left: 5px;\n\n}\n\n.automanual {\n  display: flex;\n  align-items: center;\n\n  .form-switch input {\n    height: 30px;\n    width: 50px;\n  }\n\n  .form-check-label {\n    font-size: 16px;\n    padding-top: 5px;\n    padding-left: 5px;\n  }\n}\n\n.jobcard-report-grid {\n  .card {\n    margin: 10px;\n    padding: 0px;\n\n    .card-body {\n      margin: 0px;\n      padding: 0px;\n    }\n  }\n}\n\n.center-header {\n  text-align: center;\n}\n\n.marque-card {\n  padding: 0px;\n  min-height: 60px;\n\n  .card-body {\n    padding: 5px;\n  }\n}\n\n.border-right-column {\n  border-right: 4px solid #0070bb;\n}\n\n.circle-overlay {\n  position: absolute;\n  /* use 'relative' on the parent if needed */\n  top: 10px;\n  right: 10px;\n  width: 50px;\n  height: 50px;\n  background-color: #007bff59;\n  /* Bootstrap primary blue */\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  cursor: pointer;\n  z-index: 999;\n  transition: all 0.3s ease;\n\n  i {\n    font-size: 26px;\n  }\n}\n\n.circle-overlay:hover {\n  background-color: #0056b3;\n  /* Darker on hover */\n}\n\n.pvtTable {\n  display: block;\n  max-width: 103vw;\n  /* max width is 90% of viewport width */\n  max-height: 70vh;\n  /* max height is 70% of viewport height */\n  overflow: auto;\n  border: 1px solid #ccc;\n  margin: 0 auto;\n  min-width: 600px;\n  /* optional to force min horizontal scroll */\n}\n\n.pvtUi {\n  width: 100%;\n}\n\n.pvtOutput {\n  width: 100%;\n}\n\n.pvtTotal {\n  display: none;\n}\n\n.pvtTotalLabel {\n  display: none;\n}\n\n.pvtGrandTotal {\n  display: none;\n}\n\n.pvtVals {\n  //  display: none !important;\n  visibility: hidden !important;\n}\n\n.pvtAggregator {\n  //  display: none !important;\n  visibility: hidden !important;\n\n}\n\ntable.pvtTable thead tr th,\ntable.pvtTable tbody tr th {\n  border: 1px solid #0047ab !important;\n}\n\ntable.pvtTable tbody tr td {\n  border: 1px solid #0047ab !important;\n}\n\n// .pvtVal {\n// border: 1px solid #0047ab !important;\n// }\n// .pvtColLabel {\n//   border: 1px solid #0047ab !important;\n// }\n// .pvtRowLabel {\n//     border: 1px solid #0047ab !important;\n// }\n// .pvtColLabel {\n//       border: 1px solid #0047ab !important;\n// }\n\n/* Responsive tweaks */\n@media (max-width: 768px) {\n  .pvtTable {\n    max-width: 100vw;\n    max-height: 60vh;\n    min-width: 500px;\n  }\n}\n\n/* Landscape tablets approx width between 768px and 1024px */\n@media (min-width: 769px) and (max-width: 1024px) {\n  .pvtTable {\n    max-width: 100vw;\n    /* cap at viewport width */\n    max-height: 65vh;\n    min-width: 500px;\n    /* moderate min-width */\n  }\n}\n\n@media (min-width: 1200px) {\n  .pvtTable {\n    width: 103vw;\n    max-height: 75vh;\n    min-width: 900px;\n  }\n}\n\n.pvtAxisContainer,\n.pvtVals {\n  background-color: #FFFFFF !important;\n}\n\n\n\n//Loader\n/* 3D tower loader made by: csozi | Website: www.csozi.hu*/\n\n.dots-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n  margin-top: 150px;\n}\n\n.dot {\n  height: 20px;\n  width: 20px;\n  margin-right: 10px;\n  border-radius: 10px;\n  background-color: #b3d4fc;\n  animation: pulse 1.5s infinite ease-in-out;\n}\n\n.dot:last-child {\n  margin-right: 0;\n}\n\n.dot:nth-child(1) {\n  animation-delay: -0.3s;\n}\n\n.dot:nth-child(2) {\n  animation-delay: -0.1s;\n}\n\n.dot:nth-child(3) {\n  animation-delay: 0.1s;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(0.8);\n    background-color: #b3d4fc;\n    box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);\n  }\n\n  50% {\n    transform: scale(1.2);\n    background-color: #6793fb;\n    box-shadow: 0 0 0 10px rgba(178, 212, 252, 0);\n  }\n\n  100% {\n    transform: scale(0.8);\n    background-color: #b3d4fc;\n    box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);\n  }\n}\n\n/* === Modern Card Styling === */\n.modern-card {\n  background: rgba(255, 255, 255, 0.85);\n  border-radius: 15px;\n  padding: 10px 10px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.4s ease;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.modern-card:hover {\n  transform: translateY(-6px) scale(1.03);\n  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);\n}\n\n/* === Icon Styling === */\n.modern-card .icon-wrapper {\n  background: linear-gradient(135deg, #6c5ce7, #a29bfe);\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 15px auto;\n  font-size: 1.5rem;\n  color: #fff;\n  transition: all 0.3s ease;\n}\n\n.modern-card:hover .icon-wrapper {\n  background: linear-gradient(135deg, #74b9ff, #a29bfe);\n}\n\n/* === Card Text === */\n.modern-card h5 {\n  font-weight: 600;\n  margin-bottom: 5px;\n  font-size: 1.2rem;\n}\n\n.modern-card p {\n  color: #636e72;\n  font-size: 0.9rem;\n}\n\n/* === Section Headers === */\n.menu-section h3 {\n  font-size: 1.4rem;\n  font-weight: 600;\n  margin-bottom: 20px;\n  padding-left: 10px;\n  border-left: 5px solid;\n}\n\n.masters h3 {\n  border-color: #0047ab;\n  color: #0047ab;\n}\n\n.reports h3 {\n  border-color: #f68134;\n  color: #f68134;\n}\n\n.transactions h3 {\n  border-color: #f68134;\n  color: #f68134;\n}\n\n\n\n/* === Page Title Styling === */\n.mainTitle {\n  font-size: 1.8rem;\n  font-weight: 700;\n}\n\n.subText {\n  color: #636e72;\n  margin-bottom: 20px;\n}\n\n\n// Dashboard Filter\n.filterIcon {\n  font-size: 45px;\n  justify-content: flex-end;\n  display: flex;\n  color: #008ffb;\n  cursor: pointer;\n}\n\n.filterIcon:hover {\n  color: #031422;\n}\n\n.filterBox {\n  border: 1px solid #8c8686;\n  border-radius: 8px;\n  padding: 18px 16px 0px 16px;\n  border-style: dashed;\n  margin-bottom: 20px;\n  background-color: #ffffff;\n  box-shadow: 0px 1px 9px 1px #b7b7b7;\n}\n\n.dashboard-navigate-icon {\n  font-size: 32px;\n  position: absolute;\n  top: 96px;\n  right: 10px;\n  color: #3457D5;\n  cursor: pointer;\n}\n\n.dashboard-navigate-icon:hover {\n  color: #318CE7;\n}\n\n// Dashboard Loader\n.loader-small {\n  .loader {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    width: 100%;\n  }\n\n  .loader__circle {\n    width: 14px;\n    height: 14px;\n    border-radius: 50%;\n    margin: 0 4px;\n    animation: loader_901 1s ease-in-out infinite;\n  }\n\n  .loader__circle:nth-of-type(1) {\n    background-color: #007aff;\n    animation-delay: 0;\n  }\n\n  .loader__circle:nth-of-type(2) {\n    background-color: #ff2d55;\n    animation-delay: 0.25s;\n  }\n\n  .loader__circle:nth-of-type(3) {\n    background-color: #34c759;\n    animation-delay: 0.5s;\n  }\n\n  .loader__circle:nth-of-type(4) {\n    background-color: #ff9500;\n    animation-delay: 0.75s;\n  }\n\n  @keyframes loader_901 {\n    0% {\n      transform: scale(1);\n    }\n\n    20% {\n      transform: scale(1.2);\n    }\n\n    40% {\n      transform: scale(1);\n    }\n  }\n}\n\n\n/* OEE Dashboard - Department stats grid */\n.dept-stats {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n/* Small glossy cards */\n.stat-mini {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  border-radius: 12px;\n  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\n  border: 1px solid #eef2f7;\n  box-shadow: 0 2px 6px rgba(16, 24, 40, 0.06);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.stat-mini:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 14px rgba(16, 24, 40, 0.10);\n}\n\n/* subtle left accent by tone */\n.stat-mini::before {\n  content: \"\";\n  width: 4px;\n  align-self: stretch;\n  border-radius: 8px;\n  background: #e5e7eb;\n  /* default */\n}\n\n.stat-default::before {\n  background: #d8dee9;\n}\n\n.stat-info::before {\n  background: #cfe8ff;\n}\n\n/* Produced */\n.stat-danger::before {\n  background: #ffd6d6;\n}\n\n/* Rejected */\n\n/* icon circle */\n.stat-icon {\n  width: 38px;\n  height: 38px;\n  display: grid;\n  place-items: center;\n  border-radius: 999px;\n  background: #ffffff;\n  border: 1px solid #edf1f7;\n  font-size: 18px;\n}\n\n/* text */\n.stat-body {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.1;\n}\n\n.stat-label {\n  font-size: 12px;\n  color: #6b7280;\n  /* muted */\n  margin-bottom: 6px;\n}\n\n.stat-value {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n}\n\n.stat-number {\n  font-size: 18px;\n  font-weight: 700;\n  color: #111827;\n  letter-spacing: 0.2px;\n  font-variant-numeric: tabular-nums;\n}\n\n.stat-unit {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n/* responsive: on small screens, 1 column */\n@media (max-width: 480px) {\n  .dept-stats {\n    grid-template-columns: 1fr;\n  }\n}\n\n\n/* OEE Department header styling */\n.dept-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  // background: linear-gradient(135deg, #4f46e5, #7c3aed);\n  color: white;\n  padding: 14px 0;\n  border-radius: 12px 12px 0 0;\n  box-shadow: 0 3px 10px rgba(79, 70, 229, 0.2);\n  position: relative;\n  text-align: center;\n}\n\n.dept-header::after {\n  content: \"\";\n  position: absolute;\n  bottom: -4px;\n  width: 50%;\n  height: 4px;\n  background: linear-gradient(90deg, #162435, #a78bfa);\n  border-radius: 2px;\n}\n\n.dept-badge {\n  font-size: 20px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);\n}\n\n.dept-title {\n  font-size: 12px;\n  margin-top: 4px;\n  color: #000000;\n  letter-spacing: 0.3px;\n}\n\n.section-header {\n  text-align: center;\n  margin: 40px 0 20px 0;\n  position: relative;\n}\n\n/* Section header Gradient text with shadow */\n.section-header h4 {\n  display: inline-block;\n  font-size: 24px;\n  font-weight: 700;\n  color: #000000;\n  /* Indigo tone */\n  letter-spacing: 0.5px;\n  background: linear-gradient(90deg, #000000, #020202);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.section-line {\n  width: 180px;\n  height: 4px;\n  margin: 8px auto 0;\n  border-radius: 4px;\n  background: linear-gradient(90deg, #6366f1, #a78bfa);\n  box-shadow: 0 2px 8px rgba(79, 70, 229, 0.3);\n}\n\n.progress-bar {\n  transition: width 0.4s ease-in-out;\n}\n\n.progress {\n  background-color: #e5e7eb !important;\n  border-radius: 8px;\n}\n\n// .footer-dark {\n//   background-color: #121212;\n//   color: #aaa;\n//   text-align: center;\n//   padding: 20px;\n//   font-size: 0.9rem;\n// }\n\n// .footer-dark a {\n//   color: #4dabf7;\n//   text-decoration: none;\n//   transition: color 0.3s;\n// }\n\n// .footer-dark a:hover {\n//   color: #82cfff;\n// }\n\n// .app-footer {\n//   position: fixed;\n//   bottom: 0;\n//   left: 0;\n//   width: 100%;\n//   background-color: #0b2c64; /* match your theme color */\n//   color: #fff;\n//   text-align: center;\n//   padding: 8px 0;\n//   font-size: 0.85rem;\n//   z-index: 100;\n//   span {\n//     padding-right:5px;\n//     color:#FFFFFF;\n//   } \n//   a {\n//     color:#FFFFFF;\n//   } \n//   p {\n//     padding-top: 10px;\n//   }\n// }\n\n.app-footer {\n  background-color: #0b2c64;\n  /* same blue as your theme */\n  color: #ffffff;\n  font-size: 0.85rem;\n  padding: 10px 30px;\n  width: 100%;\n  position: fixed;\n  /* or relative if you don’t want it always visible */\n  bottom: 0;\n  left: 0;\n  z-index: 100;\n}\n\n.footer-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.footer-left,\n.footer-right {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.footer-right a {\n  color: #fff;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.footer-right a:hover {\n  text-decoration: underline;\n}\n\n.dev-logo {\n  height: 16px;\n  vertical-align: middle;\n  filter: brightness(0) invert(1);\n  /* makes sure it’s visible on dark background */\n}\n\n@media (max-width: 600px) {\n  .footer-content {\n    flex-direction: column;\n    text-align: center;\n    gap: 4px;\n  }\n}\n\n.printQCLabel {\n  width: '16rem' !important;\n  margin: 0 !important;\n  /* remove bootstrap card margin */\n\n  .card-body {\n    padding: 5px;\n  }\n\n  .card-title {\n    font-size: 14px !important;\n    text-align: center;\n    font-weight: bold;\n  }\n\n  .card-subtitle {\n    font-size: 15px;\n    text-align: center;\n    font-weight: bold;\n    padding-top: 3px;\n  }\n\n  .label-size-name {\n    font-size: 12px;\n  }\n}\n\n.card-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  column-gap: 20px;\n  /* space between cards horizontally */\n  row-gap: 10px;\n}\n\n//OEE Dashboard - Ends\n\n\n//config button\n.config-icon {\n  .nav-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    i {\n      font-size: 1.5rem;\n      color: #a3e635; // yellow-green\n      cursor: pointer;\n      transition: all 0.3s ease;\n\n      text-shadow:\n        0 0 6px rgba(163, 230, 53, 0.7),\n        0 0 12px rgba(163, 230, 53, 0.5),\n        0 0 20px rgba(163, 230, 53, 0.3);\n\n      animation: deviceGlow 2s infinite;\n    }\n\n    i:hover {\n      color: #bef264;\n      transform: scale(1.15);\n    }\n  }\n}\n\n@keyframes deviceGlow {\n  0% {\n    text-shadow:\n      0 0 5px rgba(163, 230, 53, 0.5),\n      0 0 10px rgba(163, 230, 53, 0.3);\n  }\n\n  50% {\n    text-shadow:\n      0 0 10px rgba(163, 230, 53, 1),\n      0 0 20px rgba(163, 230, 53, 0.8),\n      0 0 30px rgba(163, 230, 53, 0.6);\n  }\n\n  100% {\n    text-shadow:\n      0 0 5px rgba(163, 230, 53, 0.5),\n      0 0 10px rgba(163, 230, 53, 0.3);\n  }\n}\n\n// Device Status Indicators\n.device-not-configured {\n  display: inline-block;\n  padding: 8px 14px;\n  border-radius: 12px;\n  font-weight: 700;\n  font-size: 20px;\n  color: #fff;\n  background: linear-gradient(270deg,\n      #ff416c,\n      #ff4b2b,\n      #ff416c);\n  background-size: 300% 300%;\n  animation: dangerGlow 3s ease infinite;\n  box-shadow: 0 4px 15px rgba(255, 75, 43, 0.4);\n  width: 100%;\n  text-align: center;\n  margin: 100px 0px;\n}\n\n@keyframes dangerGlow {\n  0% {\n    background-position: 0% 50%;\n    transform: scale(1);\n  }\n\n  50% {\n    background-position: 100% 50%;\n    transform: scale(1.03);\n  }\n\n  100% {\n    background-position: 0% 50%;\n    transform: scale(1);\n  }\n}\n\n.device-code {\n  display: inline-block;\n  padding: 8px 14px;\n  border-radius: 12px;\n  font-weight: 700;\n  color: #fff;\n  background: linear-gradient(135deg, #3a4892, #544dd1);\n  box-shadow: 0px 5px 12px rgb(39 49 103 / 74%);\n  width: 100%;\n  text-align: center;\n}\n\n// Pin Badge for user table \n// .pin-container {\n//   display: flex;\n//   gap: 4px;\n//   align-items: center;\n// }\n\n// .pin-digit {\n//   width: 26px;\n//   height: 26px;\n\n//   display: flex;\n//   align-items: center;\n//   justify-content: center;\n\n//   background: #ffffff;\n//   color: #000000;\n\n//   border: 1px solid #2b2b2b;\n//   border-radius: 4px;\n\n//   font-size: 16px;\n//   font-weight: 700;\n//   font-family: monospace;\n\n//   box-shadow:\n//     inset 0 1px 1px rgba(255, 255, 255, 0),\n//     0 2px 4px rgba(0, 0, 0, 0.15);\n\n//   transition: all 0.2s ease;\n\n//   &:hover {\n//     transform: translateY(-1px);\n//     background: #111;\n//   }\n// }\n\n\n.pin-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.pin-container {\n  display: flex;\n  gap: 4px;\n}\n\n.pin-digit {\n  width: 26px;\n  height: 26px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background: #ffffff;\n  color: #000000;\n\n  border-radius: 4px;\n  border: 1px solid #222;\n\n  font-size: 16px;\n  font-weight: 700;\n  font-family: monospace;\n\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n\n.pin-digit-hidden {\n  font-size: 24px;\n}\n\n.pin-toggle-btn {\n  border: none;\n  background: transparent;\n  padding: 0;\n  cursor: pointer;\n\n  i {\n    font-size: 18px;\n    color: #555;\n    transition: 0.2s ease;\n  }\n\n  &:hover i {\n    color: #000;\n  }\n}\n\n.OrderConfirmation {\n  .consumption-scroll {\n    display: flex;\n    gap: 12px;\n    overflow-x: auto;\n    overflow-y: hidden;\n    padding-bottom: 8px;\n    scroll-behavior: smooth;\n    white-space: nowrap;\n\n    &::-webkit-scrollbar {\n      height: 6px;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: #f1f1f1;\n      border-radius: 10px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: #bdbdbd;\n      border-radius: 10px;\n    }\n\n    &::-webkit-scrollbar-thumb:hover {\n      background: #999;\n    }\n  }\n\n  .consumption-mini-card {\n    flex: 0 0 240px; // fixed width card\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 15px;\n    background: #fff;\n    border: 1px solid #e9ecef;\n    border-left: 4px solid #0d6efd;\n    border-radius: 10px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n  }\n\n  .consumption-left {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .consumption-type {\n    font-size: 15px;\n    font-weight: 700;\n    color: #0d6efd;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .consumption-size {\n    font-size: 14px;\n    color: #6c757d;\n    margin-top: 4px;\n  }\n\n  .consumption-right {\n    text-align: center;\n    margin-left: 12px;\n  }\n\n  .qty-label {\n    font-size: 10px;\n    color: #6c757d;\n    text-transform: uppercase;\n  }\n\n  .qty-value {\n    margin-top: 4px;\n    min-width: 55px;\n    padding: 6px 10px;\n    background: #198754;\n    color: #fff;\n    border-radius: 8px;\n    font-size: 18px;\n    font-weight: 700;\n  }\n\n  .no-consumption-data {\n    height: 80px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    font-size: 14px;\n    font-weight: 500;\n    color: #6c757d;\n\n    border: 1px dashed #d6d6d6;\n    border-radius: 8px;\n    background: #f8f9fa;\n  }\n}\n\n.jobcard-status-summary {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));\n  gap: 12px;\n  width: 100%;\n\n  .status-card {\n    width: 100%;\n    padding: 6px;\n    border-radius: 10px;\n    color: #fff;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    .count {\n      font-size: 28px;\n      font-weight: 700;\n      line-height: 1;\n display: inline-block;\n  animation: slideUp 0.6s ease-out;\n    }\n\n    .label {\n      margin-top: 8px;\n      font-size: 13px;\n      font-weight: 500;\n    }\n  }\n\n  .all {\n    background: #34495e;\n\n    .count {\n      color: #ffffff;\n    }\n\n    .label {\n      color: #ffffff;\n    }\n  }\n\n  .inprogress {\n    background: #ffbf0044;\n\n    .count {\n      color: #FF8C00;\n    }\n\n    .label {\n      color: #FF8C00;\n    }\n  }\n\n  .open {\n    background: #0024873b;\n\n    .count {\n      color: #002387;\n    }\n\n    .label {\n      color: #002387;\n    }\n  }\n\n  .stopped {\n    background: #f30e2d3b;\n\n    .count {\n      color: #f30e2d;\n    }\n\n    .label {\n      color: #f30e2d;\n    }\n  }\n\n  .ack {\n    background: #228b223b;\n\n    .count {\n      color: #008000;\n    }\n\n    .label {\n      color: #008000;\n    }\n  }\n\n  .closed {\n    background: #55555523;\n\n    .count {\n      color: #555555b2;\n    }\n\n    .label {\n      color: #555555b2;\n    }\n  }\n\n  .complete {\n    background: #273167;\n\n    .count {\n      color: #ffffff;\n    }\n\n    .label {\n      color: #ffffff;\n    }\n  }\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n}\n\n.badge-glass {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.3;\n  letter-spacing: .3px;\n  backdrop-filter: blur(8px);\n  border: 1px solid rgba(255,255,255,.25);\n  transition: all .2s ease;\n\n  &:hover {\n    transform: translateY(-1px);\n    filter: brightness(1.05);\n  }\n}\n\n/* Blue */\n.badge-blue {\n  @extend .badge-glass;\n  background: rgba(37, 99, 235, .14);\n  color: #2563eb;\n}\n\n/* Sky */\n.badge-sky {\n  @extend .badge-glass;\n  background: rgba(14, 165, 233, .14);\n  color: #0284c7;\n}\n\n/* Cyan */\n.badge-cyan {\n  @extend .badge-glass;\n  background: rgba(6, 182, 212, .14);\n  color: #0891b2;\n}\n\n/* Teal */\n.badge-teal {\n  @extend .badge-glass;\n  background: rgba(20, 184, 166, .14);\n  color: #0f766e;\n}\n\n/* Emerald */\n.badge-emerald {\n  @extend .badge-glass;\n  background: rgba(16, 185, 129, .14);\n  color: #059669;\n}\n\n/* Green */\n.badge-green {\n  @extend .badge-glass;\n  background: rgba(34, 197, 94, .14);\n  color: #15803d;\n}\n\n/* Lime */\n.badge-lime {\n  @extend .badge-glass;\n  background: rgba(132, 204, 22, .16);\n  color: #4d7c0f;\n}\n\n/* Yellow */\n.badge-yellow {\n  @extend .badge-glass;\n  background: rgba(250, 204, 21, .18);\n  color: #a16207;\n}\n\n/* Amber */\n.badge-amber {\n  @extend .badge-glass;\n  background: rgba(245, 158, 11, .16);\n  color: #b45309;\n}\n\n/* Orange */\n.badge-orange {\n  @extend .badge-glass;\n  background: rgba(249, 115, 22, .15);\n  color: #ea580c;\n}\n\n/* Deep Orange */\n.badge-deep-orange {\n  @extend .badge-glass;\n  background: rgba(234, 88, 12, .15);\n  color: #c2410c;\n}\n\n/* Coral */\n.badge-coral {\n  @extend .badge-glass;\n  background: rgba(251, 113, 133, .15);\n  color: #e11d48;\n}\n\n/* Red */\n.badge-red {\n  @extend .badge-glass;\n  background: rgba(239, 68, 68, .15);\n  color: #dc2626;\n}\n\n/* Rose */\n.badge-rose {\n  @extend .badge-glass;\n  background: rgba(244, 63, 94, .15);\n  color: #be123c;\n}\n\n/* Pink */\n.badge-pink {\n  @extend .badge-glass;\n  background: rgba(236, 72, 153, .15);\n  color: #db2777;\n}\n\n/* Fuchsia */\n.badge-fuchsia {\n  @extend .badge-glass;\n  background: rgba(217, 70, 239, .15);\n  color: #c026d3;\n}\n\n/* Purple */\n.badge-purple {\n  @extend .badge-glass;\n  background: rgba(147, 51, 234, .15);\n  color: #7e22ce;\n}\n\n/* Violet */\n.badge-violet {\n  @extend .badge-glass;\n  background: rgba(139, 92, 246, .15);\n  color: #6d28d9;\n}\n\n/* Indigo */\n.badge-indigo {\n  @extend .badge-glass;\n  background: rgba(99, 102, 241, .15);\n  color: #4338ca;\n}\n\n/* Slate */\n.badge-slate {\n  @extend .badge-glass;\n  background: rgba(100, 116, 139, .15);\n  color: #475569;\n}\n\n/* Gray */\n.badge-gray {\n  @extend .badge-glass;\n  background: rgba(156, 163, 175, .18);\n  color: #4b5563;\n}\n\n/* Dark */\n.badge-dark {\n  @extend .badge-glass;\n  background: rgba(31, 41, 55, .12);\n  color: #1f2937;\n}\n\n/* Brown */\n.badge-brown {\n  @extend .badge-glass;\n  background: rgba(120, 53, 15, .12);\n  color: #78350f;\n}\n\n/* Chocolate */\n.badge-chocolate {\n  @extend .badge-glass;\n  background: rgba(146, 64, 14, .12);\n  color: #92400e;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
